import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
} from "reactstrap"
import { SECURITY_KEY, BASE_URL } from "../../global"
import "react-multi-carousel/lib/styles.css"

import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import classnames from "classnames"

import awicon from "../../assets/images/services-icon/coin.png"
import Select from "react-select"

import dsmile from "../../assets/images/services-icon/dog_smile.png"

//i18n
import axios from "axios"
// import { BASE_URL } from "../../global";

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import moment from "moment"

import Loader from "react-spinner-loader"

import { MathJax, MathJaxContext } from "better-react-mathjax"
import TableComm from "../../dataTableCommon"
import { Popover, UncontrolledPopover, PopoverBody } from "reactstrap";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { Table } from "reactstrap";

// import ActivityToPDFConverter from "../../components/ActivityPDFConverter/ActivityToPDFConverter";

const PreviewSummativeDetails = React.memo(() => {
  document.title = "MyGooRoo Tutor App"
  const { key } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null

  const question_no = 1

  const st_key = searchParams.get("st_key") || null

  let pk_activity_key = null
  let IsType = null
  let IsHomework = null
  let IsQuestionNo = 1
  let IsStKey = null
  if (
    key &&
    key.length >= 16 &&
    type &&
    type != null &&
    homework &&
    homework != null &&
    st_key &&
    st_key != ""
  ) {
    pk_activity_key = key
    IsType = type
    IsHomework = homework
    IsQuestionNo = question_no
    IsStKey = st_key
  } else {
    window.history.back()
  }

  //common

  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState([])
  const [summativeQuestionData, setSummativeQuestionData] = useState(null)

  // console.log(otherData);
  const authUser = JSON.parse(localStorage.getItem('authUser')) || null;

  // //pdf converter start
  // const pdfRef = useRef();
  // const [currentActivity, setCurrentActivity] = useState(null);
  //  const handleDownload = (activity) => {
  //   setCurrentActivity(activity); // Set data
  //   setTimeout(() => {
  //     pdfRef.current?.generatePDF(); // Give child time to update DOM
  //   }, 100); // Slight delay to ensure rendering
  // };
  // //pdf converter end

  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location])

  const fetchData = async () => {
    // if (authUser && authUser != "" && authUser != null) {
    if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
      setLoader(true)
      setActivityData([])
      //axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentSession/StudentPreviewAssessmentQuestions", {
          pk_activity_key: pk_activity_key,
          subject_id: type,
          pk_student_key: IsStKey,
        })
        .then(responseActivity => {
          // Assuming the API response is an array of objects with 'id' and 'value' properties
          setLoader(false)

          if (responseActivity.data.LessonActivitiesQuestions.length > 0) {
            setActivityData(responseActivity.data)
            //console.log(mergedTopics);
            setSummativeQuestionData(responseActivity?.data?.activity_node[0] || null)
          } else {
            setActivityData([])
            setSummativeQuestionData(null)
          }
        })
        .catch(error => {
          setLoader(false)
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
          ) {
          localStorage.clear()
          window.history.back()
          }
        })
    } else {
      setLoader(false)
      window.history.back()
    }
    // } else {
    //   // setLoader(false);
    //   window.history.back()
    // }
  }

  

  const CountTotalCoins = question => {
    let total_coins = 0

    if (question && question.length > 0) {
      question.forEach(activity => {
        if (activity.fk_sub_id === "1") {
          if (
            activity.english_question &&
            (parseInt(
              activity.english_question[0]?.english_question_category_id
            ) === 10 ||
              parseInt(
                activity.english_question[0]?.english_question_category_id
              ) === 13)
          ) {
            activity.english_question.map((question, index1) => {
              let total_part = question.english_question_parts
              let array_part_data = total_part.filter(
                part =>
                  part.english_question_answers?.length > 0 &&
                  part.english_question_answers[0]?.english_answer_text &&
                  part.english_question_answers[0]?.english_answer_text != ""
              )
              total_coins += array_part_data.length * 2 || 0
            })
          } else {
            total_coins += activity?.english_question?.reduce(
              (acc, question) =>
                acc + question?.english_question_parts?.length * 2,
              0
            )
          }
          // total_coins += activity.english_question.reduce((acc, question) => acc + question.english_question_parts.length * 2, 0);
        } else if (activity.fk_sub_id === "2" || activity.fk_sub_id === "3") {
          total_coins += activity?.question?.reduce(
            (acc, question) => acc + question?.question_parts?.length * 2,
            0
          )
        }
      })
    }
    // setTotalCoins(total_coins);
    return total_coins
  }

 

  const [customActiveTab, setcustomActiveTab] = useState(IsQuestionNo)

  function toggleCustom(tab) {
    // console.log(tab);
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  
  function rearrangeEvenOddSecond(array) {
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    return rearranged // Return the final rearranged array
  }

  function rearrangeEvenOdd(array) {
    array.sort((a, b) => {
      const textA = a.english_answer_text || a.answer_text || "";
      const textB = b.english_answer_text || b.answer_text || "";
      return textA.localeCompare(textB);
    });
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    // Check if further rearrangement is needed
    if (rearranged.length > 1) {
      return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
    }

    return rearranged // Return the final rearranged array
  }

  

  //Maths Answer guid start
  const [openAccordion, setOpenAccordion] = useState("1");
  
  // const togglePopover = () => setPopoverOpen(!popoverOpen);
  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? "" : id);
  };

  
  
  //Maths Answer guid end



  const [questionId, setQuestionId] = useState(0)
  const [existingData, setExistingValue] = useState([])

  const [studentKey, setStudentKey] = useState("")
  const [UpcomingSessionData, setUpcomingSessionData] = useState([])
  const [modal_move_activity, setmodal_move_activity] = useState(false)
  const [moveingSessionKey, setmoveingSessionKey] = useState([])
  const [rollOveractiveTabSingle, setrollOverActiveTabSingle] = useState("lessonPlan")
  const tog_move_activity = () => {
    handlerollOverTabChangeSingle("lessonPlan")
    setmodal_move_activity(!modal_move_activity)
  }

  const handlerollOverTabChangeSingle = tab => {
    setrollOverActiveTabSingle(tab)

    const updatedSessions = UpcomingSessionData.map(session => ({
      ...session,
      checked: false,
    }))

    //console.log(updatedSessions)

    setUpcomingSessionData(updatedSessions)
    setmoveingSessionKey([])
  }

  const handleCheckboxChange = (key, isChecked) => {
    const updatedSessions = UpcomingSessionData.map(session => {
      if (session.pk_ses_key === key) {
        return { ...session, checked: isChecked }
      }
      return session
    })

    setUpcomingSessionData(updatedSessions)
    if (isChecked) {
      // Add key to the selectedKeys array if checked
      setmoveingSessionKey(prev => [...prev, key])
    } else {
      // Remove key from the selectedKeys array if unchecked
      setmoveingSessionKey(prev => prev.filter(k => k !== key))
    }
  }

  const [isMASubmitting, setIsMASubmitting] = useState(false)
  const [modal_moveing_conform, setmodal_moveing_conform] = useState(false)
  const tog_moveing_popup = () => {
    setmodal_moveing_conform(!modal_moveing_conform)
  }

  
  const fetchUpcommingSessionData = async () => {
    // console.log(studentKey);
    if (authUser && authUser != "" && authUser != null) {
     
      setStudentKey(ActivityData.fk_student_key)
      if(ActivityData && ActivityData!=''){
        try {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          const uniqueSubjects = [ActivityData].reduce((acc, item) => {
            if (!acc.some(obj => obj.subject_id === item.fk_sub_id)) {
              acc.push({ subject_id: item.fk_sub_id })
            }
            return acc
          }, [])
          //console.log(uniqueSubjects);
          const responseSessionUpcomingList = await axios.post(
            BASE_URL + "session/getAllUpcommingActivitySessionList",
            {
              pk_student_key: ActivityData.fk_student_key,
              fk_subject_id: uniqueSubjects,
            }
          ) //console.log(studentKey);
          //console.log(responseUpcomingList)
          if (responseSessionUpcomingList.data.length > 0) {
            const updatedData = responseSessionUpcomingList.data.map(item => ({
              ...item,
              checked: false, // Add the checked property to each item
            }))
            setUpcomingSessionData(updatedData)
              //setUpcomingSessionData(responseUpcomingList.data);
            setmodal_move_activity(true)
            //handlerollOverTabChangeSingle("lessonPlan")
          } else {
            toast.error("Not found upcoming sessions!", {
              autoClose: 3000, // 3 seconds in this example
            })
            setUpcomingSessionData([])
            setmodal_move_activity(false)
          }
          //setstudentDetail(responseStudent.data.data.data)
        } catch (error) {
          console.error("Error in fetching upcoming session deatails:", error)
        }
      }
    } else {
      navigate("/login")
      //setLoading(false)
    }
  }

  const columns_session = [
    {
      name: "Date",
      Header: "Date",
      accessor: row => (row.ses_date ? new Date(row.ses_date) : null), // Use raw date for sorting
      Cell: ({ value }) => {
        if (!value) return "-"

        const day = String(value.getDate()).padStart(2, "0")
        const month = String(value.getMonth() + 1).padStart(2, "0")
        const year = value.getFullYear()
        return `${day}-${month}-${year}`
      },
      // disableFilters: true,
      // disableSortBy: true,
    },
    {
      name: "Session Name",
      Header: "Session Name",
      // accessor: 'st_first_name',
      accessor: row =>
        row.sest_name && row.sest_name != "" ? row.sest_name : "-",
    },
    {
      name: "Subject",
      Header: "Subject",
      accessor: row =>
        row.sub_name != null && row.sub_name != "" ? row.sub_name : "-",
    },
    {
      name: "Action",
      Header: "Action",
      accessor: "pk_ses_key",
      Cell: ({ row }) => {
        const { pk_ses_key } = row.values

        return (
          <input
            type="checkbox"
            className="form-check-input"
            checked={row.original.checked}
            onChange={e => handleCheckboxChange(pk_ses_key, e.target.checked)}
          />
        )
      },
      //accessor: row => row.attendance_status != null && row.attendance_status != '' ? parseInt(row.attendance_status) === 0 ? 'Pending' : parseInt(row.attendance_status) === 1 ? 'Ongoing' : parseInt(row.attendance_status) === 2 ? 'Attended' : parseInt(row.attendance_status) === 6 ? 'Canceled' : 'Pending': '-',
    },

    //  {
    //       Header: "Status",
    //       disableSortBy: true,
    //       accessor: 'pk_student_key',
    //       disableFilters: true,

    //       Cell: ({ row }) => (<><button className='btn status-btn'> ON GOING</button></>),

    // },
    // {
    //       Header: "#",
    //       disableSortBy: true,
    //       accessor: 'pk_student_keys',
    //       disableFilters: true,

    //       Cell: ({ row }) => (<><button className='btn'><i class="mdi mdi-chevron-right-circle-outline" style={{ color: '#979797', fontSize: '20px'}}></i></button></>),

    // },
    // {
    //   accessor: 'student_key', disableSortBy: true, disableFilters: true,           isVisible: false,

    //   selector: (row) => row.values.pk_student_key, show: false,
    // },
  ]






  const handleAssignClick = (dataId) => {
    // console.log(topicTitle)
    // console.log(topic)
    setQuestionId(dataId);
    const foundQuestion = summativeQuestionData?.questions.find(q => q.questionId === dataId && q.assignedCount <= 0);

    let mergedData = {}

    if (foundQuestion) {
      /* Assessment */


      if (foundQuestion.questionId) {

        mergedData = {
          id: foundQuestion.NodeIdNew,
          name: foundQuestion.NodeIdNew,
          subject_id: foundQuestion.subjectId,
          topicID: foundQuestion.TopicIdNew,
          coin: 2,
          duration: "10 mins",
          is_homework: 0,
          type: "Assessment",

          activity_node_id: foundQuestion.NodeIdNew,
          activity_type: 0,
          level_id: foundQuestion.LevelIdNew,
          level_name: foundQuestion.LevelIdNew,
        }
       
      } else {

        toast.error("Selected activity does not have any question.", {
          autoClose: 3000, // 3 seconds in this example
        })
        return;
      }
    } else {
      /* Else */
      toast.error("Activities alreay assigned", {
        autoClose: 3000, // 3 seconds in this example
      })
      return;
    }

    

    // Concatenate the new merged data with existing data

    let newValue = [];//existingData.concat(mergedData)
    newValue.push(mergedData);

    setExistingValue(newValue || [])
    fetchUpcommingSessionData();
    //fetchOPHData();
  }


  const OnSubmitActivityData = async () => {
    try {
      // setLoader(true)

      if (moveingSessionKey.length === 0) {
        toast.error("Please select at least one session!", {
          autoClose: 3000, // 3 seconds in this example
        })
        return;
      } 

      if (authUser && authUser != "" && authUser != null) {
        if (
          moveingSessionKey && existingData
        ) {
           setIsMASubmitting(true);
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`

          const response = await axios
            .post(BASE_URL + "activity/createActivitiesMultipleSession", {
              activities: existingData || [],
              is_homework: rollOveractiveTabSingle === "homework" ? 1 : 0,
              lesson_key: "",
              session_keys: moveingSessionKey || [],
              student_key: ActivityData.fk_student_key || "",
              pk_lesson_activity_key: ActivityData.pk_lesson_activity_key,
              fk_question_id: questionId
            })
            .then(responseActivity => {
              // Assuming the API response is an array of objects with 'id' and 'value' properties
              const activitiesData = responseActivity.data

              if (activitiesData == 1) {
                // Reset the form
                //formRef.current.reset();
                fetchData()
                toast.success(" Activities added successfully", {
                  autoClose: 3000, // 3 seconds in this example
                  
                })
                setmodal_move_activity(false)
                setIsMASubmitting(false) // Re-enable the submit button
                setQuestionId(0)
                setExistingValue([])
                //setLoader(false)
              } else {
                fetchData()
                toast.success(" Activities added successfully", {
                  autoClose: 3000, // 3 seconds in this example
                  
                })
                setmodal_move_activity(false)
                setIsMASubmitting(false) // Re-enable the submit button
                setQuestionId(0)
                setExistingValue([])
                //localStorage.removeItem("selectedData")
                //setLoader(false)
              }
            })
            .catch(error => {
              console.error("Error fetching options from API: ", error)
              //setLoader(false)
            })
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error("Failure! Unable to create notes. Try again later", {
        autoClose: 3000, // 3 seconds in this example
      })

      setIsMASubmitting(false) // Re-enable the submit button
    } finally {
      setIsMASubmitting(false) // Re-enable the submit button
    }
  }
  return (
    <React.Fragment>
      <MathJax inline dynamic>
        <Loader
          show={loader}
          type="body"
          // stack="vertical"
          // message="Loading Data"
        />
        <ToastContainer autoClose={3000} />
        
        <Modal
        isOpen={modal_move_activity}
        toggle={tog_move_activity}
        size="lg"
        centered
      >
        <ModalHeader
          className="mt-0 w-100"
          close={
            moveingSessionKey.length > 0 ? (
              <button
                className="btn bg-danger text-white text-uppercase position-absolute top-3 end-0 me-3"
                disabled={isMASubmitting}
                onClick={() => {
                  OnSubmitActivityData()
                }}
              >
                Submit
              </button>
            ) : (
              ""
            )
          }
        >
          {/* Tab Navigation */}

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTabSingle === "lessonPlan" ? "active" : ""
                }`}
                id="lessonPlan-tab"
                data-bs-toggle="tab"
                role="tab"
                // onClick={() => {
                //   setrollOverActiveTab("lessonPlan")
                //   setmoveingMultipleSessionKey([])
                // }}
                onClick={() => handlerollOverTabChangeSingle("lessonPlan")}
              >
                Assign to lesson plan
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTabSingle === "homework" ? "active" : ""
                }`}
                id="homework-tab"
                data-bs-toggle="tab"
                role="tab"
                // onClick={() => {
                //   setrollOverActiveTab("homework")
                //   setmoveingMultipleSessionKey([])
                // }}
                onClick={() => handlerollOverTabChangeSingle("homework")}
              >
               Assign to home work
              </a>
            </li>
          </ul>
        </ModalHeader>

        <ModalBody className="text-center">
          <div>
            {/* Tab Content */}
            <div className="tab-content mt-3">
              <div
                className={`tab-pane fade ${
                  rollOveractiveTabSingle === "lessonPlan" ? "show active" : ""
                }`}
                // id="lessonPlan"
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_session}
                  defaultId={"ses_date"}
                  data={UpcomingSessionData}
                />
              </div>
              <div
                className={`tab-pane fade ${
                  rollOveractiveTabSingle === "homework" ? "show active" : ""
                }`}
                // id="homework"
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_session}
                  defaultId={"ses_date"}
                  data={UpcomingSessionData}
                />
                {/* <p>
                  Click submit to roll over all activities to the same session
                  home work
                </p>
                <button
                  className="btn bg-danger text-white text-uppercase position-absolute top-3 end-0 me-3"
                  onClick={() => {
                    onMoveingMultipleActivityHomePopup()
                  }}
                >
                  Submit
                </button> */}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
       

        <div className="page-wrapper">
          <div className="cs-pg-header bg-dark-blue py-4">
            <Container className="custom-wt">
              <div className="d-flex align-items-center">
                <div
                  className="mt-0 border-right me-4"
                  style={{ width: "20%" }}
                >
                  <div
                    className="text-white font-size-14 text-uppercase"
                    to={"#"}
                    onClick={() => history.back()}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    back
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                  <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                  {ActivityData && ActivityData?.activity_type === 0 && ActivityData.activity_node && ActivityData.activity_node[0]?.node_name ? ActivityData.activity_node[0].node_name : null}
                  {ActivityData && ActivityData?.activity_type === 8 && ActivityData.activity_node && ActivityData.activity_node[0]?.name ? ActivityData.activity_node[0].name : null}
                    
                  </h6>
                  <p className="mb-0 text-uppercase luminous-wht">
                    {" "}
                    <span className="text-yellow me-1">
                      {ActivityData && ActivityData.subject_name
                        ? ActivityData.subject_name
                        : null}
                    </span>{" "}
                    {ActivityData?.activity_type === 8 ? "Summative" :  "Online Activities"}{" "}
                  </p>
                  <div className="luminous-wht font-size-16">
                    <img width={24} className="" src={awicon} alt="" />{" "}
                    {ActivityData && ActivityData.coins_earned
                      ? ActivityData.coins_earned
                      : 0}
                    /
                    {ActivityData &&
                    ActivityData.LessonActivitiesQuestions &&
                    ActivityData.LessonActivitiesQuestions.length > 0
                      ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)
                      : 0}{" "}
                    coins earned
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <Container className="custom-wt">
            <div className="assessement-section summary-width-hold mt-2">
              {/* <div>
                <div className="d-flex justify-content-end me-3">
                  <span onClick={() => handleDownload(ActivityData)}><i className="mdi mdi-file-pdf-box" style={{fontSize: "30px"}}></i></span>
                </div>
                <ActivityToPDFConverter ref={pdfRef} ActivityData={currentActivity} type='page' />
              </div> */}
              <Nav tabs className="nav-tabs-custom mb-3">
                {ActivityData &&
                ActivityData.LessonActivitiesQuestions &&
                ActivityData.LessonActivitiesQuestions.length > 0
                  ? ActivityData.LessonActivitiesQuestions.map(
                      (activity, index) => {
                        if (
                          activity.english_question &&
                          activity.english_question.length > 0 &&
                          parseInt(activity.fk_sub_id) === 1
                        ) {
                          return activity.english_question.map(
                            (question, index1) => {
                              if (
                                parseInt(
                                  question.english_question_category_id
                                ) === 1 ||
                                parseInt(
                                  question.english_question_category_id
                                ) === 8 ||
                                parseInt(
                                  question.english_question_category_id
                                ) === 2 ||
                                parseInt(
                                  question.english_question_category_id
                                ) === 12 ||
                                parseInt(
                                  question.english_question_category_id
                                ) === 13 ||
                                parseInt(
                                  question.english_question_category_id
                                ) === 10
                              ) {
                                // let filteredManualMark =
                                //   question.english_question_parts.filter(
                                //     manualMark =>
                                //       parseInt(
                                //         manualMark.english_question_part_automark
                                //       ) === 0
                                //   )
                                let filteredManualMark = question.english_question_parts.filter(manualMark => ((parseInt(manualMark.english_question_part_automark) === 0 && manualMark.english_question_answers 
                                                          && manualMark.english_question_answers.length > 0 
                                                          && manualMark.english_question_answers[0].english_answer_text 
                                                          && manualMark.english_question_answers[0].english_answer_text!='' ))) 
                                let question_status = 1

                                // console.log(active_state)
                                if (
                                  question.english_question_parts &&
                                  question.english_question_parts.length > 0
                                ) {
                                  //let total_coins = question.english_question_parts.length * 2;
                                  //setTotalCoins(prevTotalCoins => prevTotalCoins + total_coins);
                                  question.english_question_parts.forEach(
                                    (activityQuestionPart, index2) => {
                                      let partManualMark = parseInt(
                                        activityQuestionPart.english_question_part_automark
                                      )

                                      let total_mark = 0
                                      if (
                                        activityQuestionPart.StudentAnsAttempts &&
                                        activityQuestionPart.StudentAnsAttempts
                                          .length > 0
                                      ) {
                                        activityQuestionPart.StudentAnsAttempts.forEach(
                                          (stuAnswer, index3) => {
                                            if (
                                              stuAnswer.points_obtained != null
                                            ) {
                                              total_mark += parseInt(
                                                stuAnswer.points_obtained
                                              ) // Increment count_answer by 1 for each occurrence
                                            }
                                          }
                                        )

                                        if(((activityQuestionPart?.markedReport > 0 && activityQuestionPart.StudentAnsAttempts.length >=1) || 
                                       (activityQuestionPart.StudentAnsAttempts.length >=2)) && total_mark === 0){
                                          question_status = 3
                                        } else if (
                                          activityQuestionPart
                                            .StudentAnsAttempts.length >= 1 &&
                                          total_mark >= 2
                                        ) {
                                          question_status = 4
                                        } else if (
                                          activityQuestionPart
                                            .StudentAnsAttempts.length >= 1 &&
                                          total_mark > 0
                                        ) {
                                          question_status = 5
                                        } else if (
                                          activityQuestionPart
                                            .StudentAnsAttempts.length === 1 &&
                                          total_mark >= 0 &&
                                          partManualMark <= 0
                                        ) {
                                          question_status = 2
                                        } else {
                                          question_status = 2
                                        }
                                      } else {
                                        question_status = 2
                                      }
                                      // console.log('status -'+i+' - '+question_status);
                                    }
                                  )
                                }

                                return (
                                  <NavItem key={index}>
                                    <NavLink
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleCustom(index + 1)
                                      }}
                                      className={
                                        parseInt(customActiveTab) === index + 1
                                          ? "active"
                                          : "" + question_status &&
                                            question_status === 1
                                          ? " display-hold_active"
                                          : question_status &&
                                            question_status === 2
                                          ? " display-number"
                                          : question_status &&
                                            question_status === 3
                                          ? " display-attempt_fail"
                                          : question_status &&
                                            question_status === 4
                                          ? " display-attempt1"
                                          : question_status &&
                                            question_status === 5
                                          ? " display-attempt2"
                                          : " display-number"
                                      }
                                    >
                                      {question_status &&
                                      question_status === 1 ? (
                                        <span className="font-size-20 fw-bold">
                                          {filteredManualMark.length > 0
                                            ? "M"
                                            : index + 1}
                                        </span>
                                      ) : question_status &&
                                        question_status === 2 ? (
                                        <span className="font-size-20 fw-bold">
                                          {filteredManualMark.length > 0
                                            ? "M"
                                            : index + 1}
                                        </span>
                                      ) : question_status &&
                                        question_status === 3 ? (
                                        filteredManualMark.length > 0 ? (
                                          <span className="font-size-20 fw-bold">
                                            M
                                          </span>
                                        ) : (
                                          <i className="mdi mdi-close-thick text-danger font-size-20"></i>
                                        )
                                      ) : question_status &&
                                        question_status === 4 ? (
                                        filteredManualMark.length > 0 ? (
                                          <span className="font-size-20 fw-bold">
                                            M
                                          </span>
                                        ) : (
                                          <i className="fas fa-check text-success font-size-20"></i>
                                        )
                                      ) : question_status &&
                                        question_status === 5 ? (
                                        filteredManualMark.length > 0 ? (
                                          <span className="font-size-20 fw-bold">
                                            M
                                          </span>
                                        ) : (
                                          <i className="fas fa-check text-warning font-size-20"></i>
                                        )
                                      ) : (
                                        <span className="font-size-20 fw-bold">
                                          {filteredManualMark.length > 0
                                            ? "M"
                                            : index + 1}
                                        </span>
                                      )}
                                    </NavLink>

                                    {/* } */}
                                  </NavItem>
                                )
                              }
                            }
                          )
                        } else if (
                          activity.question &&
                          activity.question.length > 0 &&
                          parseInt(activity.fk_sub_id) === 2
                        ) {
                          //maths
                          return activity.question.map((question, index1) => {
                            // console.log('enter2')
                            if (question.question_id != null) {
                              let filteredManualMark = []
                              //let filteredManualMark = question.question_parts.filter(manualMark => ((parseInt(manualMark.english_question_part_automark) === 0)))
                              let question_status = 1

                              if (
                                question.question_parts &&
                                question.question_parts.length > 0
                              ) {
                                //let total_coins = question.english_question_parts.length * 2;
                                //setTotalCoins(prevTotalCoins => prevTotalCoins + total_coins);
                                question.question_parts.forEach(
                                  (activityQuestionPart, index2) => {
                                    //let partManualMark = parseInt(activityQuestionPart.english_question_part_automark);

                                    let total_mark = 0
                                    if (
                                      activityQuestionPart.StudentAnsAttempts &&
                                      activityQuestionPart.StudentAnsAttempts
                                        .length > 0
                                    ) {
                                      activityQuestionPart.StudentAnsAttempts.forEach(
                                        (stuAnswer, index3) => {
                                          if (
                                            stuAnswer.points_obtained != null
                                          ) {
                                            total_mark += parseInt(
                                              stuAnswer.points_obtained
                                            ) // Increment count_answer by 1 for each occurrence
                                          }
                                        }
                                      )

                                      if(((activityQuestionPart?.markedReport > 0 && activityQuestionPart.StudentAnsAttempts.length >=1) 
                                        || (activityQuestionPart.StudentAnsAttempts.length >=2)) && total_mark === 0){
                                        question_status = 3
                                      } else if (
                                        activityQuestionPart.StudentAnsAttempts
                                          .length >= 1 &&
                                        total_mark >= 2
                                      ) {
                                        question_status = 4
                                      } else if (
                                        activityQuestionPart.StudentAnsAttempts
                                          .length === 2 &&
                                        total_mark > 0
                                      ) {
                                        question_status = 5

                                        // }else if(activityQuestionPart.StudentAnsAttempts.length ===1 && total_mark >= 0 && partManualMark <= 0){
                                        //   question_status = 2;
                                      } else {
                                        question_status = 2
                                      }
                                    } else {
                                      question_status = 2
                                    }
                                    // console.log('status -'+i+' - '+question_status);
                                  }
                                )
                              }

                              return (
                                <NavItem key={index}>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      toggleCustom(index + 1)
                                    }}
                                    className={
                                      parseInt(customActiveTab) === index + 1
                                        ? "active"
                                        : "" + question_status &&
                                          question_status === 1
                                        ? " display-hold_active"
                                        : question_status &&
                                          question_status === 2
                                        ? " display-number"
                                        : question_status &&
                                          question_status === 3
                                        ? " display-attempt_fail"
                                        : question_status &&
                                          question_status === 4
                                        ? " display-attempt1"
                                        : question_status &&
                                          question_status === 5
                                        ? " display-attempt2"
                                        : " display-number"
                                    }
                                  >
                                    {question_status &&
                                    question_status === 1 ? (
                                      <span className="font-size-20 fw-bold">
                                        {filteredManualMark.length > 0
                                          ? "M"
                                          : index + 1}
                                      </span>
                                    ) : question_status &&
                                      question_status === 2 ? (
                                      <span className="font-size-20 fw-bold">
                                        {filteredManualMark.length > 0
                                          ? "M"
                                          : index + 1}
                                      </span>
                                    ) : question_status &&
                                      question_status === 3 ? (
                                      filteredManualMark.length > 0 ? (
                                        <span className="font-size-20 fw-bold">
                                          M
                                        </span>
                                      ) : (
                                        <i className="mdi mdi-close-thick text-danger font-size-20"></i>
                                      )
                                    ) : question_status &&
                                      question_status === 4 ? (
                                      filteredManualMark.length > 0 ? (
                                        <span className="font-size-20 fw-bold">
                                          M
                                        </span>
                                      ) : (
                                        <i className="fas fa-check text-success font-size-20"></i>
                                      )
                                    ) : question_status &&
                                      question_status === 5 ? (
                                      filteredManualMark.length > 0 ? (
                                        <span className="font-size-20 fw-bold">
                                          M
                                        </span>
                                      ) : (
                                        <i className="fas fa-check text-warning font-size-20"></i>
                                      )
                                    ) : (
                                      <span className="font-size-20 fw-bold">
                                        {filteredManualMark.length > 0
                                          ? "M"
                                          : index + 1}
                                      </span>
                                    )}
                                  </NavLink>

                                  {/* } */}
                                </NavItem>
                              )
                            }
                          })
                        } else {
                          //else
                        }
                      }
                    )
                  : null}
              </Nav>
              <p className="font-size-16 fw-semibold mb-2 mt-2">
                {ActivityData?.marked_for_homework >= 0 && (
                  <>
                    {ActivityData?.homework_tutor_message && ActivityData.marked_for_homework == 1 ? (
                      <>
                        <b>Tutor message:</b> {ActivityData.homework_tutor_message}
                      </>
                    ) : ActivityData?.lesson_tutor_message ? (
                      <>
                        <b>Tutor message:</b> {ActivityData.lesson_tutor_message}
                      </>
                    ) : null}
                  </>
                )}
              </p>
              <p className="font-size-16 fw-semibold mb-2">
                {ActivityData?.tutor_comments && (
                  <>
                    <b>Tutor comments:</b> {ActivityData.tutor_comments}
                  </>
                )}
              </p>
              <TabContent activeTab={customActiveTab} className="text-muted">
                {ActivityData &&
                ActivityData.LessonActivitiesQuestions &&
                ActivityData.LessonActivitiesQuestions.length > 0
                  ? ActivityData.LessonActivitiesQuestions.map(
                      (ActivityData1, activeindex) => {
                        if (
                          ActivityData1.english_question &&
                          ActivityData1.english_question.length > 0 &&
                          parseInt(ActivityData1.fk_sub_id) === 1
                        ) {
                          return ActivityData1.english_question.map(
                            (InnerActivityData, index) => {
                              if (index === 0) {
                                if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 1
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div className="hw-list mt-4 pb-100">
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .level_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .level_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .strand_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .strand_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .topic_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .sub_topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .sub_topic_name
                                                  : null}
                                              </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.english_question_id
                                                    ? InnerActivityData.english_question_id
                                                    : null}
                                                </p>
                                                <span>
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                              </div>
                                            </div>
                                            <div class="d-flex justify-content-between gap-3 mb-3">
                                            <div
                                              className="mt-4"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.english_question_text
                                                    ? InnerActivityData.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>
                                             {InnerActivityData.english_question_parts &&
                                                InnerActivityData.english_question_parts.map((quspart, index) => (
                                                  <div key={index}>
                                                    {((quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1)) && (
                                                      quspart.markedReport && quspart.markedReport > 0 ?
                                                      <div>
                                                        {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                        <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                      </div>
                                                      :
                                                      null
                                                      
                                                    )}
                                                  </div>
                                                ))}
                                            </div>

                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                              {InnerActivityData.english_question_parts &&
                                                InnerActivityData.english_question_parts.map(
                                                  (quspart, index) => {
                                                    //const stuAnswersarray = quspart.StudentAnsAttempts.map(stuAns => stuAns.student_answer);

                                                    const stuAnswersarray =
                                                      quspart.StudentAnsAttempts.map(
                                                        stuAns => {
                                                          try {
                                                            return JSON.parse(
                                                              stuAns.student_answer
                                                            )
                                                          } catch (error) {
                                                            console.error(
                                                              "Error parsing JSON:",
                                                              error
                                                            )
                                                            return null // or handle the error in an appropriate way
                                                          }
                                                        }
                                                      ) || [] // Extracting session keys

                                                    // Assuming stuAnswersarray is a nested array
                                                    const flattenedStuAnswers =
                                                      [].concat(
                                                        ...stuAnswersarray
                                                      )
                                                    let serialNumber = 0
                                                    //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                    return (
                                                      quspart.english_question_answers &&
                                                      rearrangeEvenOdd(
                                                        quspart.english_question_answers
                                                      ).map(
                                                        (qusAns, index1) => {
                                                          const cleanText =
                                                            qusAns.english_answer_text
                                                              .replace(
                                                                /&nbsp;/g,
                                                                ""
                                                              )
                                                              .replace(/`/g, "")
                                                              .replace(
                                                                /<[^>]*>/g,
                                                                ""
                                                              )
                                                              .trim()

                                                          const hasImage =
                                                            /<img\s+[^>]*>/gi.test(
                                                              qusAns.english_answer_text
                                                            )

                                                          if (
                                                            !cleanText &&
                                                            !hasImage
                                                          ) {
                                                            return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                          }
                                                          serialNumber++
                                                          let filteredStuAns =
                                                            flattenedStuAnswers.filter(
                                                              stuAns =>
                                                                parseInt(
                                                                  stuAns.part_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_part_id
                                                                  ) &&
                                                                parseInt(
                                                                  stuAns.answer_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                            ) || []
                                                            
                                                          let filteredStuAnsoverridedata = quspart.StudentAnsAttempts.filter(stuAns => ((parseInt(stuAns.attempt_status) ===1))
                                                            ) || [];
                                                          const stuAnswersoverridearray = filteredStuAnsoverridedata.map(stuAns => {
                                                            try {
                                                                return JSON.parse(stuAns.student_answer);
                                                                } catch (error) {
                                                                    console.error('Error parsing JSON:', error);
                                                                    return null; // or handle the error in an appropriate way
                                                                }
                                                            }) || [];
                                                          const flattenedoverrideStuAnswers = [].concat(...stuAnswersoverridearray);

                                                          let filteredStuAnsoverride = flattenedoverrideStuAnswers.filter(stuAns => ((parseInt(stuAns.part_id) === parseInt(qusAns.english_answer_part_id)) 
                                                          && (parseInt(stuAns.answer_id) === parseInt(qusAns.english_answer_id)))
                                                          ) || [];

                                                          var status_color =
                                                            "selector-general cursor-pointer"
                                                          var border_color =
                                                            "border-start-secondary"
                                                          if (
                                                            filteredStuAns.length >
                                                            0
                                                          ) {
                                                            if(parseInt(qusAns.english_answer_is_correct) === 1 && !quspart?.markedReport > 0){
                                                              status_color = 'selector-success';
                                                              border_color = 'border-start-success';
                                                            } else if(filteredStuAnsoverride.length > 0 && quspart.markedReport > 0) {
                                                              status_color = 'selector-success';
                                                              border_color = 'border-start-success';
                                                            } else {
                                                              status_color = "selector-wrong ";
                                                              border_color = "border-start-danger";
                                                            }
                                                          }
                                                          //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                          return (
                                                            <li
                                                              className={
                                                                status_color +
                                                                " choose e_choose"
                                                              }
                                                              key={index1}
                                                            >
                                                              <div className="p-2 px-3 font-size-18">
                                                                {serialNumber}
                                                              </div>
                                                              <div
                                                                className={
                                                                  "p-2 dg-media " +
                                                                  {
                                                                    border_color,
                                                                  }
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    qusAns.english_answer_text
                                                                      ? qusAns.english_answer_text
                                                                      : null,
                                                                }}
                                                              ></div>
                                                            </li>
                                                          )
                                                        }
                                                      )
                                                    )
                                                  }
                                                )}
                                            </ul>
                                            <>
                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                Feedback
                                              </h4>
                                              <div
                                                className="e_feedBack"
                                                style={{
                                                  border: "1px solid #1a1a1a",
                                                  borderRadius: "4px",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                {InnerActivityData.english_question_parts &&
                                                  InnerActivityData.english_question_parts.map(
                                                    (quspart, index) => {
                                                      let filteredAns =
                                                        quspart.english_question_answers.filter(
                                                          CorrAns =>
                                                            parseInt(
                                                              CorrAns.english_answer_is_correct
                                                            ) === 1
                                                        )
                                                      return filteredAns.map(
                                                        (qusAns, index1) => {
                                                          return (
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  qusAns.english_answer_text
                                                                    ? qusAns.english_answer_text
                                                                    : null,
                                                              }}
                                                            ></div>
                                                          )
                                                        }
                                                      )
                                                    }
                                                  )}
                                              </div>
                                            </>
                                          </li>
                                        </ul>

                                       

                                         <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            
                                            <div className={activeindex + 1 > 1 ? "" : "invisible"}>
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(activeindex)
                                                }}>
                                                Prev
                                                </Button>
                                            </div>

                                            {/* Middle Button (Replace) */}
                                            <div className="text-center">
                                                <Button
                                                className="btn btn-danger cs-btn-danger mt-1"
                                                disabled={!!summativeQuestionData?.questions.find(q => q.questionId === InnerActivityData?.english_question_id && q.assignedCount > 0)}
                                                onClick={() => {
                                                    handleAssignClick(InnerActivityData?.english_question_id)
                                                }}
                                                >
                                                Assign Actvity
                                                </Button>
                                            </div>

                                            {/* Right Button (Next) */}
                                            <div
                                                className={
                                                    activeindex + 1 <
                                                    ActivityData.LessonActivitiesQuestions.length
                                                    ? ""
                                                    : "invisible"
                                                }
                                            >
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(
                                                    activeindex + 1 + 1
                                                    )
                                                }}>
                                                Next
                                                </Button>
                                            </div>
                                        </div>

                                       
                                      </div>
                                    </TabPane>
                                  )
                                } else if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  (parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 8 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 2 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 12)
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div className="hw-list mt-4 pb-100 not_scroll">
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .level_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .level_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .strand_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .strand_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .topic_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .sub_topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .sub_topic_name
                                                  : null}
                                              </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.english_question_id
                                                    ? InnerActivityData.english_question_id
                                                    : null}
                                                </p>
                                                <span>
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                              </div>
                                            </div>
                                            <div className="question-container-custom mt-2">
                                              <div className="passage-area flex-fill border" >
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      InnerActivityData.english_question_instruction
                                                        ? InnerActivityData.english_question_instruction
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                        : null,
                                                  }}
                                                ></div>

                                                {/* Choice */}
                                                {InnerActivityData &&
                                                InnerActivityData.english_question_choices &&
                                                InnerActivityData
                                                  .english_question_choices.length >
                                                  0 ? (
                                                  <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                    {InnerActivityData.english_question_choices.map(
                                                      (qusChoice, Cindex) => (
                                                        <div
                                                          class="choice-options_child"
                                                          key={Cindex}
                                                        >
                                                          <div>
                                                            {qusChoice.choice_no}
                                                          </div>
                                                          <div>
                                                            {qusChoice.choice_text}
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                ) : null}

                                                
                                                {InnerActivityData.english_question_text &&
                                                parseInt(
                                                  InnerActivityData.english_question_category_id
                                                ) === 8 ? (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.english_question_text
                                                          ? InnerActivityData.english_question_text
                                                              .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /&nbsp;/g,
                                                                ""
                                                              )
                                                              .split("</p>")
                                                              .map(
                                                                (
                                                                  paragraph,
                                                                  index
                                                                ) =>
                                                                  paragraph
                                                                    ? `<div class="d-flex"><p class="me-2">${
                                                                        index + 1
                                                                      } ${paragraph}</p></div>`
                                                                    : ""
                                                              )
                                                              .filter(Boolean)
                                                              .join("")
                                                          : null,
                                                    }}
                                                  />
                                                ) : (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.english_question_text
                                                          ? InnerActivityData.english_question_text
                                                              .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                          : null,
                                                    }}
                                                  ></div>
                                                )}
                                                {InnerActivityData &&
                                                InnerActivityData.part_heading &&
                                                InnerActivityData.part_heading !=
                                                  "" ? (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.part_heading,
                                                    }}
                                                  ></div>
                                                ) : null}
                                                {/* File option */}
                                                <div className="mt-4 my-2">
                                                  {InnerActivityData &&
                                                  InnerActivityData.english_question_files &&
                                                  InnerActivityData
                                                    .english_question_files.length >
                                                    0
                                                    ? InnerActivityData.english_question_files.map(
                                                        (qusFile, imgindex) => (
                                                          <img
                                                            key={imgindex}
                                                            alt=""
                                                            style={{
                                                              height: "auto",
                                                              maxWidth: "100%",
                                                            }}
                                                            src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                          />
                                                        )
                                                      )
                                                    : null}
                                                </div>

                                              </div>

                                              <div className="question-area flex-fill border">   
                                                {/* Past question */}
                                                {InnerActivityData.english_question_parts &&
                                                  InnerActivityData.english_question_parts.map(
                                                    (quspart, index) => {
                                                      const stuAnswersarray =
                                                        quspart.StudentAnsAttempts.map(
                                                          stuAns => {
                                                            try {
                                                              return JSON.parse(
                                                                stuAns.student_answer
                                                              )
                                                            } catch (error) {
                                                              console.error(
                                                                "Error parsing JSON:",
                                                                error
                                                              )
                                                              return null // or handle the error in an appropriate way
                                                            }
                                                          }
                                                        ) || [] // Extracting session keys

                                                      // Assuming stuAnswersarray is a nested array
                                                      const flattenedStuAnswers =
                                                        [].concat(
                                                          ...stuAnswersarray
                                                        )
                                                      let serialNumber = 0
                                                      return (
                                                        <div key={index}>
                                                          <div class="d-flex justify-content-between gap-3 mb-3">
                                                          <div className="d-flex gap-2 flex-row ">
                                                            <div className="mr-3">
                                                              {index + 1}
                                                              {")"}
                                                            </div>
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  quspart.english_question_part_text
                                                                    ? quspart.english_question_part_text
                                                                        .replace(
                                                                          /\[(\d+)Answer char=\d+\]/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /\[Answer char=\d+\]/g,
                                                                          ""
                                                                        )
                                                                    : null,
                                                              }}
                                                            ></div>
                                                          </div>
                                                          {(quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1) ? 
                                                              quspart.markedReport && quspart.markedReport > 0 ?
                                                              <div>
                                                                {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                              </div>
                                                              :
                                                              null
                                                              : 
                                                              null
                                                            }
                                                          </div>
                                                          {/* Anse category statement Star */}
                                                          {quspart.english_question_part_answer_type ===
                                                            8 ||
                                                          quspart.english_question_part_answer_type ===
                                                            1 ||
                                                          quspart.english_question_part_answer_type ===
                                                            7 ? (
                                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                                              {" "}
                                                              {parseInt(
                                                                quspart.english_question_part_automark
                                                              ) === 1 ? (
                                                                ""
                                                              ) : (
                                                                <div className="d-flex justify-content-end">
                                                                  <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                    Manual Marking
                                                                  </span>
                                                                </div>
                                                              )}
                                                              {quspart.english_question_answers &&
                                                                quspart.english_question_answers.map(
                                                                  (
                                                                    qusAns,
                                                                    index1
                                                                  ) => {
                                                                    // Your logic for filtering student answers and determining status_color and border_color
                                                                    const stuAnswersarray =
                                                                      quspart.StudentAnsAttempts.map(
                                                                        stuAns => {
                                                                          try {
                                                                            return JSON.parse(
                                                                              stuAns.student_answer
                                                                            )
                                                                          } catch (error) {
                                                                            console.error(
                                                                              "Error parsing JSON:",
                                                                              error
                                                                            )
                                                                            return null // or handle the error in an appropriate way
                                                                          }
                                                                        }
                                                                      ) || [] // Extracting session keys
                                                                    //console.log(stuAnswersarray);
                                                                    // Assuming stuAnswersarray is a nested array
                                                                    const flattenedStuAnswers =
                                                                      [].concat(
                                                                        ...stuAnswersarray
                                                                      )
                                                                    let cleanedText =
                                                                      qusAns.english_answer_text
                                                                        .replace(
                                                                          /&nbsp;/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /`/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /<[^>]*>/g,
                                                                          ""
                                                                        ) || ""
                                                                    let resultTest =
                                                                      cleanedText
                                                                        .toLowerCase()
                                                                        .trim()
                                                                    let answers =
                                                                      resultTest.split(
                                                                        "|"
                                                                      ) || []
                                                                    let firstAnswer =
                                                                      answers[0]
                                                                        ? answers[0].trim()
                                                                        : ""
                                                                    let secondAnswer =
                                                                      answers[1]
                                                                        ? answers[1].trim()
                                                                        : ""
                                                                    let answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || []; 

                                                                    if (
                                                                      qusAns.english_answer_is_correct ===
                                                                      1
                                                                    ) {
                                                                      let filteredStuAns =
                                                                        flattenedStuAnswers.filter(
                                                                          stuAns =>
                                                                            parseInt(
                                                                              stuAns.part_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_part_id
                                                                              ) &&
                                                                            (stuAns.text
                                                                              .toLowerCase()
                                                                              .trim() ==
                                                                              resultTest ||
                                                                              stuAns.text
                                                                                .toLowerCase()
                                                                                .trim() ==
                                                                                firstAnswer ||
                                                                              stuAns.text
                                                                                .toLowerCase()
                                                                                .trim() ==
                                                                                secondAnswer ||
                                                                                answersArray.some(answer => answer == stuAns.text
                                                                                  .toLowerCase()
                                                                                  .trim())) &&
                                                                            parseInt(
                                                                              stuAns.answer_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_id
                                                                              )
                                                                        ) || []

                                                                      let filteredAllStuAns =
                                                                        flattenedStuAnswers.filter(
                                                                          stuAns =>
                                                                            parseInt(
                                                                              stuAns.part_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_part_id
                                                                              ) &&
                                                                            parseInt(
                                                                              stuAns.answer_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_id
                                                                              )
                                                                        ) || []

                                                                      return (
                                                                        <li
                                                                          key={
                                                                            index1
                                                                          }
                                                                          className={
                                                                            parseInt(
                                                                              quspart.english_question_part_automark
                                                                            ) === 1
                                                                              ? filteredStuAns.length >
                                                                                0
                                                                                ? "input_box e_input_box"
                                                                                : "input_box e_input_box"
                                                                              : " input_box e_input_box"
                                                                          }
                                                                        >
                                                                        { parseInt(InnerActivityData.english_question_category_id) === 2 ?
                                                                          <input
                                                                          id={
                                                                            index1 +
                                                                            Math.floor(
                                                                              Math.random() *
                                                                                5
                                                                            )
                                                                          }
                                                                          type="text"
                                                                          className={
                                                                            parseInt(
                                                                              quspart.english_question_part_automark
                                                                            ) ===
                                                                              1 &&
                                                                            quspart
                                                                              .StudentAnsAttempts
                                                                              .length >
                                                                              0
                                                                              ? ((filteredStuAns.length > 0 && !quspart?.markedReport > 0) || 
                                                                                (quspart?.markedReport > 0 && quspart.StudentAnsAttempts.some(attempt => parseInt(attempt.attempt_status) == 1)))
                                                                                ? "answersuccess"
                                                                                : "answererror "
                                                                              : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                : "answererror" 
                                                                              : "answereditor"
                                                                          }
                                                                          value={
                                                                            filteredAllStuAns
                                                                              .filter(
                                                                                item =>
                                                                                  parseInt(
                                                                                    item.answer_id
                                                                                  ) ===
                                                                                  parseInt(
                                                                                    qusAns.english_answer_id
                                                                                  )
                                                                              )
                                                                              .reverse()
                                                                              .map(
                                                                                item =>
                                                                                  item.text
                                                                              )
                                                                              .find(
                                                                                text =>
                                                                                  text !==
                                                                                  undefined
                                                                              ) ||
                                                                            "" // Find the first non-undefined text value
                                                                          }
                                                                          disabled={
                                                                            true
                                                                          }
                                                                          //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                          onChange={e =>
                                                                            handletext(
                                                                              e,
                                                                              qusAns.english_answer_id,
                                                                              qusAns.english_answer_part_id
                                                                            )
                                                                          }
                                                                          // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                        />
                                                                        :
                                                                          <textarea
                                                                            id={
                                                                              index1 +
                                                                              Math.floor(
                                                                                Math.random() *
                                                                                  5
                                                                              )
                                                                            }
                                                                            type="text"
                                                                            className={
                                                                              parseInt(
                                                                                quspart.english_question_part_automark
                                                                              ) ===
                                                                                1 &&
                                                                              quspart
                                                                                .StudentAnsAttempts
                                                                                .length >
                                                                                0
                                                                                ? filteredStuAns.length >
                                                                                  0
                                                                                  ? "answersuccess"
                                                                                  : "answererror "
                                                                                : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                  quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                  : "answererror" 
                                                                                : "answereditor"
                                                                            }
                                                                            value={
                                                                              filteredAllStuAns
                                                                                .filter(
                                                                                  item =>
                                                                                    parseInt(
                                                                                      item.answer_id
                                                                                    ) ===
                                                                                    parseInt(
                                                                                      qusAns.english_answer_id
                                                                                    )
                                                                                )
                                                                                .reverse()
                                                                                .map(
                                                                                  item =>
                                                                                    item.text
                                                                                )
                                                                                .find(
                                                                                  text =>
                                                                                    text !==
                                                                                    undefined
                                                                                ) ||
                                                                              "" // Find the first non-undefined text value
                                                                            }
                                                                            disabled={
                                                                              true
                                                                            }
                                                                            //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            onChange={e =>
                                                                              handletext(
                                                                                e,
                                                                                qusAns.english_answer_id,
                                                                                qusAns.english_answer_part_id
                                                                              )
                                                                            }
                                                                            // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                          />
                                                                        }
                                                                        </li>
                                                                      )
                                                                    }
                                                                  }
                                                                )}
                                                            </ul>
                                                          ) : quspart.english_question_part_answer_type ===
                                                            4 ? (
                                                            //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                                              {parseInt(
                                                                quspart.english_question_part_automark
                                                              ) === 1 ? (
                                                                ""
                                                              ) : (
                                                                <div className="d-flex justify-content-end">
                                                                  <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                    Manual Marking
                                                                  </span>
                                                                </div>
                                                              )}
                                                              {quspart.english_question_answers &&
                                                                rearrangeEvenOdd(
                                                                  quspart.english_question_answers
                                                                ).map(
                                                                  (
                                                                    qusAns,
                                                                    index1
                                                                  ) => {
                                                                    const cleanText =
                                                                      qusAns.english_answer_text
                                                                        .replace(
                                                                          /&nbsp;/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /`/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /<[^>]*>/g,
                                                                          ""
                                                                        )
                                                                        .trim()

                                                                    const hasImage =
                                                                      /<img\s+[^>]*>/gi.test(
                                                                        qusAns.english_answer_text
                                                                      )

                                                                    if (
                                                                      !cleanText &&
                                                                      !hasImage
                                                                    ) {
                                                                      return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                    }

                                                                    serialNumber++

                                                                    let filteredStuAns =
                                                                      flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                          parseInt(
                                                                            stuAns.part_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_part_id
                                                                            ) &&
                                                                          parseInt(
                                                                            stuAns.answer_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_id
                                                                            )
                                                                      ) || []

                                                                    //OverRide check status start
                                                                    let filteredStuAnsoverridedata = quspart.StudentAnsAttempts.filter(stuAns => ((parseInt(stuAns.attempt_status) ===1))
                                                                    ) || [];
                                                                    const stuAnswersoverridearray = filteredStuAnsoverridedata.map(stuAns => {
                                                                      try {
                                                                          return JSON.parse(stuAns.student_answer);
                                                                          } catch (error) {
                                                                              console.error('Error parsing JSON:', error);
                                                                              return null; // or handle the error in an appropriate way
                                                                          }
                                                                      }) || [];
                                                                    const flattenedoverrideStuAnswers = [].concat(...stuAnswersoverridearray);

                                                                    let filteredStuAnsoverride = flattenedoverrideStuAnswers.filter(stuAns => ((parseInt(stuAns.part_id) === parseInt(qusAns.english_answer_part_id)) 
                                                                    && (parseInt(stuAns.answer_id) === parseInt(qusAns.english_answer_id)))
                                                                    ) || [];
                                                                    
                                                                    //OverRide check status end

                                                                    var status_color =
                                                                      "selector-general cursor-pointer"
                                                                    var border_color =
                                                                      "border-start-secondary"
                                                                    if (
                                                                      filteredStuAns.length >
                                                                        0 &&
                                                                      parseInt(
                                                                        quspart.english_question_part_automark
                                                                      ) === 1
                                                                    ) {
                                                                      if((parseInt(qusAns.english_answer_is_correct) === 1 && !quspart?.markedReport > 0)){
                                                                        status_color = 'selector-success';
                                                                        border_color = 'border-start-success';
                                                                      }else if(filteredStuAnsoverride.length > 0 && quspart.markedReport > 0) {
                                                                        status_color = 'selector-success';
                                                                        border_color = 'border-start-success';
                                                                      } else {
                                                                        status_color ="selector-wrong ";
                                                                        border_color ="border-start-danger";
                                                                      }
                                                                    }else if(quspart.StudentAnsAttempts.length > 0  &&
                                                                            quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1){
                                                                        if (
                                                                          quspart.StudentAnsAttempts[0].attempt_status == 1
                                                                        ) {
                                                                          status_color =
                                                                            "selector-success"
                                                                          border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                          status_color =
                                                                            "selector-wrong "
                                                                          border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                    }

                                                                    
                                                                    //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                    return (
                                                                      <li
                                                                        className={
                                                                          status_color +
                                                                          " choose e_choose"
                                                                        }
                                                                        key={index1}
                                                                      >
                                                                        <div className="p-2 px-3 font-size-18">
                                                                          {
                                                                            serialNumber
                                                                          }
                                                                        </div>
                                                                        <div
                                                                          className={
                                                                            "p-2 dg-media " +
                                                                            {
                                                                              border_color,
                                                                            }
                                                                          }
                                                                          dangerouslySetInnerHTML={{
                                                                            __html:
                                                                              qusAns.english_answer_text
                                                                                ? qusAns.english_answer_text
                                                                                : null,
                                                                          }}
                                                                        ></div>
                                                                      </li>
                                                                    )
                                                                  }
                                                                )}
                                                            </ul>
                                                          ) : (
                                                            <p className="text-center">
                                                              No option
                                                            </p>
                                                          )}
                                                          {/* Anse category statement end */}
                                                        </div>
                                                      )
                                                    }
                                                  )}

                                                {/* past question End */}


                                                <>
                                                  <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                    Feedback
                                                  </h4>
                                                  <div
                                                    className="e_feedBack"
                                                    style={{
                                                      border: "1px solid #1a1a1a",
                                                      borderRadius: "4px",
                                                      fontSize: "16px",
                                                    }}
                                                  >
                                                    {InnerActivityData.english_question_parts &&
                                                      InnerActivityData.english_question_parts.map(
                                                        (quspart, index) => (
                                                          <div
                                                            className="d-flex gap-2 flex-row"
                                                            key={index}
                                                          >
                                                            <div className="mr-3">
                                                              {index + 1}
                                                            </div>
                                                            {quspart.english_question_answers
                                                              .filter(
                                                                CorrAns =>
                                                                  parseInt(
                                                                    CorrAns.english_answer_is_correct
                                                                  ) === 1
                                                              )
                                                              .map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => (
                                                                  <div
                                                                    key={index1}
                                                                    dangerouslySetInnerHTML={{
                                                                      __html:
                                                                        qusAns.english_answer_text
                                                                          ? qusAns.english_answer_text
                                                                          : null,
                                                                    }}
                                                                  ></div>
                                                                )
                                                              )}
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>

                                        <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            
                                            <div className={activeindex + 1 > 1 ? "" : "invisible"}>
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(activeindex)
                                                }}>
                                                Prev
                                                </Button>
                                            </div>

                                            {/* Middle Button (Replace) */}
                                            <div className="text-center">
                                                <Button
                                                className="btn btn-danger cs-btn-danger mt-1"
                                                disabled={!!summativeQuestionData?.questions.find(q => q.questionId === InnerActivityData?.english_question_id && q.assignedCount > 0)}
                                                onClick={() => {
                                                    handleAssignClick(InnerActivityData?.english_question_id)
                                                }}
                                                >
                                                Assign Actvity
                                                </Button>
                                            </div>

                                            {/* Right Button (Next) */}
                                            <div
                                                className={
                                                    activeindex + 1 <
                                                    ActivityData.LessonActivitiesQuestions.length
                                                    ? ""
                                                    : "invisible"
                                                }
                                            >
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(
                                                    activeindex + 1 + 1
                                                    )
                                                }}>
                                                Next
                                                </Button>
                                            </div>
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  (parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 13 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 10)
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div className="hw-list mt-4 pb-100 not_scroll">
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .level_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .level_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .strand_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .strand_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .topic_name + " /"
                                                  : null}

                                                {InnerActivityData.english_question_has_sub_topic &&
                                                InnerActivityData
                                                  .english_question_has_sub_topic
                                                  .sub_topic_name
                                                  ? InnerActivityData
                                                      .english_question_has_sub_topic
                                                      .sub_topic_name
                                                  : null}
                                              </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.english_question_id
                                                    ? InnerActivityData.english_question_id
                                                    : null}
                                                </p>
                                                <span
                                                  
                                                >
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                              </div>
                                            </div>
                                            <div
                                              className="mt-3"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.english_question_instruction
                                                    ? InnerActivityData.english_question_instruction
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>
                                            {/* Choice */}
                                            {InnerActivityData &&
                                            InnerActivityData.english_question_choices &&
                                            InnerActivityData
                                              .english_question_choices.length >
                                              0 ? (
                                              <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                {InnerActivityData.english_question_choices.map(
                                                  (qusChoice, Cindex) => (
                                                    <div
                                                      class="choice-options_child"
                                                      key={Cindex}
                                                    >
                                                      <div>
                                                        {qusChoice.choice_no}
                                                      </div>
                                                      <div>
                                                        {qusChoice.choice_text}
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            ) : null}

                                            <div
                                              className="mt-4"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.english_question_text
                                                    ? InnerActivityData.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>
                                            {InnerActivityData &&
                                            InnerActivityData.part_heading &&
                                            InnerActivityData.part_heading !=
                                              "" ? (
                                              <div
                                                className="mt-4"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    InnerActivityData.part_heading,
                                                }}
                                              ></div>
                                            ) : null}
                                            {/* File option */}
                                            <div className="mt-4 my-2">
                                              {InnerActivityData &&
                                              InnerActivityData.english_question_files &&
                                              InnerActivityData
                                                .english_question_files.length >
                                                0
                                                ? InnerActivityData.english_question_files.map(
                                                    (qusFile, imgindex) => (
                                                      <img
                                                        key={imgindex}
                                                        alt=""
                                                        style={{
                                                          height: "auto",
                                                          maxWidth: "100%",
                                                        }}
                                                        src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                      />
                                                    )
                                                  )
                                                : null}
                                            </div>

                                            {/* Past question */}
                                            {InnerActivityData.english_question_parts &&
                                              InnerActivityData.english_question_parts.map(
                                                (quspart, index) => {
                                                  if (
                                                    quspart.english_question_answers &&
                                                    quspart
                                                      .english_question_answers
                                                      .length > 0 &&
                                                    quspart
                                                      .english_question_answers[0]
                                                      .english_answer_text &&
                                                    quspart
                                                      .english_question_answers[0]
                                                      .english_answer_text != ""
                                                  ) {
                                                    const stuAnswersarray =
                                                      quspart.StudentAnsAttempts.map(
                                                        stuAns => {
                                                          try {
                                                            return JSON.parse(
                                                              stuAns.student_answer
                                                            )
                                                          } catch (error) {
                                                            console.error(
                                                              "Error parsing JSON:",
                                                              error
                                                            )
                                                            return null // or handle the error in an appropriate way
                                                          }
                                                        }
                                                      ) || [] // Extracting session keys

                                                    // Assuming stuAnswersarray is a nested array
                                                    const flattenedStuAnswers =
                                                      [].concat(
                                                        ...stuAnswersarray
                                                      )
                                                    let serialNumber = 0
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="d-flex justify-content-between align-items-center mt-3"
                                                      >
                                                        <div class="d-flex justify-content-between gap-3 mb-3">
                                                        <div className="d-flex gap-2 flex-row ">
                                                          {/* <div className="mr-3">{index + 1}</div> */}
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                quspart.english_question_part_text
                                                                  ? quspart.english_question_part_text
                                                                      .replace(
                                                                        /\[\[(.+?)\]\]/g,
                                                                        function (
                                                                          match,
                                                                          p1
                                                                        ) {
                                                                          return p1.length >
                                                                            1
                                                                            ? `<span class="text-bg-yellow">${p1}</span>`
                                                                            : `<span class="text-bg-blue">${p1}</span>`
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        /\{\{/g,
                                                                        "<u>"
                                                                      )
                                                                      .replace(
                                                                        /\}\}/g,
                                                                        "</u>"
                                                                      )
                                                                      .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                  : null,
                                                            }}
                                                          ></div>
                                                        </div>
                                                        {(quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 1) || (quspart.english_question_part_automark != 1 && ActivityData1.marked_for_manual_marking == 1) ? 
                                                          quspart.markedReport && quspart.markedReport > 0 ?
                                                          <div>
                                                            {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                            <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                          </div>
                                                          :
                                                          null
                                                          : 
                                                          null
                                                        }
                                                      </div>
                                                        {/* Anse category statement Star */}
                                                        {quspart.english_question_part_answer_type ===
                                                          8 ||
                                                        quspart.english_question_part_answer_type ===
                                                          1 ||
                                                        quspart.english_question_part_answer_type ===
                                                          7 ? (
                                                          <ul className="dg-selector width-controll list-unstyled mb-0">
                                                            {" "}
                                                            {parseInt(
                                                              quspart.english_question_part_automark
                                                            ) === 1 ? (
                                                              ""
                                                            ) : (
                                                              <div className="d-flex justify-content-end">
                                                                <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                  Manual Marking
                                                                </span>
                                                              </div>
                                                            )}
                                                            {quspart.english_question_answers &&
                                                              quspart.english_question_answers.map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => {
                                                                  // Your logic for filtering student answers and determining status_color and border_color
                                                                  const stuAnswersarray =
                                                                    quspart.StudentAnsAttempts.map(
                                                                      stuAns => {
                                                                        try {
                                                                          return JSON.parse(
                                                                            stuAns.student_answer
                                                                          )
                                                                        } catch (error) {
                                                                          console.error(
                                                                            "Error parsing JSON:",
                                                                            error
                                                                          )
                                                                          return null // or handle the error in an appropriate way
                                                                        }
                                                                      }
                                                                    ) || [] // Extracting session keys
                                                                  //console.log(stuAnswersarray);
                                                                  // Assuming stuAnswersarray is a nested array
                                                                  const flattenedStuAnswers =
                                                                    [].concat(
                                                                      ...stuAnswersarray
                                                                    )
                                                                  let cleanedText =
                                                                    qusAns.english_answer_text
                                                                      .replace(
                                                                        /&nbsp;/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /`/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /<[^>]*>/g,
                                                                        ""
                                                                      ) || ""
                                                                  let resultTest =
                                                                    cleanedText
                                                                      .toLowerCase()
                                                                      .trim()
                                                                  let answers =
                                                                    resultTest.split(
                                                                      "|"
                                                                    ) || []
                                                                  let firstAnswer =
                                                                    answers[0]
                                                                      ? answers[0].trim()
                                                                      : "No_Data"
                                                                  let secondAnswer =
                                                                    answers[1]
                                                                      ? answers[1].trim()
                                                                      : "No_Data"
                                                                  let answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || []; 
                                                                  if (
                                                                    qusAns.english_answer_is_correct ===
                                                                    1
                                                                  ) {
                                                                    let filteredStuAns =
                                                                      flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                          parseInt(
                                                                            stuAns.part_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_part_id
                                                                            ) &&
                                                                          (stuAns.text
                                                                            .toLowerCase()
                                                                            .trim() ==
                                                                            resultTest ||
                                                                            stuAns.text
                                                                              .toLowerCase()
                                                                              .trim() ==
                                                                              firstAnswer ||
                                                                            stuAns.text
                                                                              .toLowerCase()
                                                                              .trim() ==
                                                                              secondAnswer ||
                                                                            answersArray.some(answer => answer == stuAns.text
                                                                              .toLowerCase()
                                                                              .trim())) &&
                                                                          parseInt(
                                                                            stuAns.answer_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_id
                                                                            )
                                                                      ) || []

                                                                    let filteredAllStuAns =
                                                                      flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                          parseInt(
                                                                            stuAns.part_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_part_id
                                                                            ) &&
                                                                          parseInt(
                                                                            stuAns.answer_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_id
                                                                            )
                                                                      ) || []

                                                                    return (
                                                                      <li
                                                                        key={
                                                                          index1
                                                                        }
                                                                        className={
                                                                          parseInt(
                                                                            quspart.english_question_part_automark
                                                                          ) ===
                                                                          1
                                                                            ? filteredStuAns.length >
                                                                              0
                                                                              ? "input_box small_input_box"
                                                                              : "input_box small_input_box"
                                                                            : " input_box small_input_box"
                                                                        }
                                                                      >
                                                                        <input
                                                                          id={
                                                                            index1 +
                                                                            Math.floor(
                                                                              Math.random() *
                                                                                5
                                                                            )
                                                                          }
                                                                          type="text"
                                                                          className={
                                                                            parseInt(
                                                                              quspart.english_question_part_automark
                                                                            ) ===
                                                                              1 &&
                                                                            quspart
                                                                              .StudentAnsAttempts
                                                                              .length >
                                                                              0
                                                                              ? ((filteredStuAns.length > 0 && !quspart?.markedReport > 0) || 
                                                                                (quspart?.markedReport > 0 && quspart.StudentAnsAttempts.some(attempt => parseInt(attempt.attempt_status) == 1)))
                                                                                ? "answersuccess"
                                                                                : "answererror "
                                                                              : quspart.StudentAnsAttempts.length > 0 && quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1 ? 
                                                                                quspart.StudentAnsAttempts[0].attempt_status == 1 ?  "answersuccess"
                                                                                : "answererror" 
                                                                              : "answereditor"
                                                                          }
                                                                          value={
                                                                            filteredAllStuAns
                                                                              .filter(
                                                                                item =>
                                                                                  parseInt(
                                                                                    item.answer_id
                                                                                  ) ===
                                                                                  parseInt(
                                                                                    qusAns.english_answer_id
                                                                                  )
                                                                              )
                                                                              .reverse()
                                                                              .map(
                                                                                item =>
                                                                                  item.text
                                                                              )
                                                                              .find(
                                                                                text =>
                                                                                  text !==
                                                                                  undefined
                                                                              ) ||
                                                                            "" // Find the first non-undefined text value
                                                                          }
                                                                          disabled={
                                                                            true
                                                                          }
                                                                          //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                          onChange={e =>
                                                                            handletext(
                                                                              e,
                                                                              qusAns.english_answer_id,
                                                                              qusAns.english_answer_part_id
                                                                            )
                                                                          }
                                                                          // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                        />
                                                                      </li>
                                                                    )
                                                                  }
                                                                }
                                                              )}
                                                          </ul>
                                                        ) : quspart.english_question_part_answer_type ===
                                                          4 ? (
                                                          //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                          <ul className="dg-selector width-controll list-unstyled mb-0">
                                                            {parseInt(
                                                              quspart.english_question_part_automark
                                                            ) === 1 ? (
                                                              ""
                                                            ) : (
                                                              <div className="d-flex justify-content-end">
                                                                <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                  Manual Marking
                                                                </span>
                                                              </div>
                                                            )}
                                                            {quspart.english_question_answers &&
                                                              rearrangeEvenOdd(
                                                                quspart.english_question_answers
                                                              ).map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => {
                                                                  const cleanText =
                                                                    qusAns.english_answer_text
                                                                      .replace(
                                                                        /&nbsp;/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /`/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /<[^>]*>/g,
                                                                        ""
                                                                      )
                                                                      .trim()

                                                                  const hasImage =
                                                                    /<img\s+[^>]*>/gi.test(
                                                                      qusAns.english_answer_text
                                                                    )

                                                                  if (
                                                                    !cleanText &&
                                                                    !hasImage
                                                                  ) {
                                                                    return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                  }

                                                                  serialNumber++

                                                                  let filteredStuAns =
                                                                    flattenedStuAnswers.filter(
                                                                      stuAns =>
                                                                        parseInt(
                                                                          stuAns.part_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_part_id
                                                                          ) &&
                                                                        parseInt(
                                                                          stuAns.answer_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_id
                                                                          )
                                                                    ) || []
                                                                    
                                                                  //OverRide check status start
                                                                    let filteredStuAnsoverridedata = quspart.StudentAnsAttempts.filter(stuAns => ((parseInt(stuAns.attempt_status) ===1))
                                                                    ) || [];
                                                                    const stuAnswersoverridearray = filteredStuAnsoverridedata.map(stuAns => {
                                                                      try {
                                                                          return JSON.parse(stuAns.student_answer);
                                                                          } catch (error) {
                                                                              console.error('Error parsing JSON:', error);
                                                                              return null; // or handle the error in an appropriate way
                                                                          }
                                                                      }) || [];
                                                                    const flattenedoverrideStuAnswers = [].concat(...stuAnswersoverridearray);

                                                                    let filteredStuAnsoverride = flattenedoverrideStuAnswers.filter(stuAns => ((parseInt(stuAns.part_id) === parseInt(qusAns.english_answer_part_id)) 
                                                                    && (parseInt(stuAns.answer_id) === parseInt(qusAns.english_answer_id)))
                                                                    ) || [];
                                                                    
                                                                  //OverRide check status end
                                                                  var status_color =
                                                                    "selector-general cursor-pointer"
                                                                  var border_color =
                                                                    "border-start-secondary"
                                                                  if (
                                                                    filteredStuAns.length >
                                                                      0 &&
                                                                    parseInt(
                                                                      quspart.english_question_part_automark
                                                                    ) === 1
                                                                  ) {
                                                                    if((parseInt(qusAns.english_answer_is_correct) === 1 && !quspart?.markedReport > 0)){
                                                                      status_color = 'selector-success';
                                                                      border_color = 'border-start-success';
                                                                    }else if(filteredStuAnsoverride.length > 0 && quspart.markedReport > 0) {
                                                                      status_color = 'selector-success';
                                                                      border_color = 'border-start-success';
                                                                    } else {
                                                                      status_color = "selector-wrong ";
                                                                      border_color = "border-start-danger";
                                                                    }
                                                                  }else if(quspart.StudentAnsAttempts.length > 0 &&
                                                                    quspart.english_question_part_automark == 0 && ActivityData1.marked_for_manual_marking == 1){
                                                                    if (
                                                                      quspart.StudentAnsAttempts[0].attempt_status == 1
                                                                    ) {
                                                                      status_color =
                                                                        "selector-success"
                                                                      border_color =
                                                                        "border-start-success"
                                                                    } else {
                                                                      status_color =
                                                                        "selector-wrong "
                                                                      border_color =
                                                                        "border-start-danger"
                                                                    }
                                                                }
                                                                  //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                  return (
                                                                    <li
                                                                      className={
                                                                        status_color +
                                                                        " choose e_choose"
                                                                      }
                                                                      key={
                                                                        index1
                                                                      }
                                                                    >
                                                                      <div className="p-2 px-3 font-size-18">
                                                                        {
                                                                          serialNumber
                                                                        }
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          "p-2 dg-media " +
                                                                          {
                                                                            border_color,
                                                                          }
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            qusAns.english_answer_text
                                                                              ? qusAns.english_answer_text
                                                                              : null,
                                                                        }}
                                                                      ></div>
                                                                    </li>
                                                                  )
                                                                }
                                                              )}
                                                          </ul>
                                                        ) : (
                                                          <p className="text-center">
                                                            No option
                                                          </p>
                                                        )}
                                                        {/* Anse category statement end */}
                                                      </div>
                                                    )
                                                  } else {
                                                    return quspart.english_question_part_text ? (
                                                      <div
                                                        key={index}
                                                        className="mt-3"
                                                      >
                                                        <div className="d-flex gap-2 flex-row ">
                                                          {/* <div className="mr-3">{index + 1}</div> */}
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                quspart.english_question_part_text
                                                                  ? quspart.english_question_part_text
                                                                      .replace(
                                                                        /\[\[(.+?)\]\]/g,
                                                                        function (
                                                                          match,
                                                                          p1
                                                                        ) {
                                                                          return p1.length >
                                                                            1
                                                                            ? `<span class="text-bg-yellow">${p1}</span>`
                                                                            : `<span class="text-bg-blue">${p1}</span>`
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        /\{\{/g,
                                                                        "<u>"
                                                                      )
                                                                      .replace(
                                                                        /\}\}/g,
                                                                        "</u>"
                                                                      )
                                                                      .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                  : null,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      </div>
                                                    ) : null
                                                  }
                                                }
                                              )}

                                            {/* past question End */}

                                            <>
                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                Feedback
                                              </h4>
                                              <div
                                                className="e_feedBack gap-5 d-flex"
                                                style={{
                                                  border: "1px solid #1a1a1a",
                                                  borderRadius: "4px",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                <div>
                                                  {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                      (quspart, index) => {
                                                        if (
                                                          quspart.english_question_answers &&
                                                          quspart
                                                            .english_question_answers
                                                            .length > 0 &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text !=
                                                            ""
                                                        ) {
                                                          return (
                                                            <div
                                                              className="d-flex gap-2 flex-row"
                                                              key={index}
                                                            >
                                                              {/* <div className="mr-3">{index + 1}</div> */}
                                                              {quspart.english_question_answers
                                                                .filter(
                                                                  CorrAns =>
                                                                    parseInt(
                                                                      CorrAns.english_answer_is_correct
                                                                    ) === 1
                                                                )
                                                                .map(
                                                                  (
                                                                    qusAns,
                                                                    index1
                                                                  ) => (
                                                                    <div
                                                                      key={
                                                                        index1
                                                                      }
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          qusAns.english_answer_text
                                                                            ? qusAns.english_answer_text
                                                                            : null,
                                                                      }}
                                                                    ></div>
                                                                  )
                                                                )}
                                                            </div>
                                                          )
                                                        }
                                                      }
                                                    )}
                                                </div>
                                                <div>
                                                  {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                      (quspart, index) => {
                                                        if (
                                                          quspart.english_question_answers &&
                                                          quspart
                                                            .english_question_answers
                                                            .length > 0 &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text !=
                                                            ""
                                                        ) {
                                                          return (
                                                            <div
                                                              className="d-flex gap-2 flex-row"
                                                              key={index}
                                                            >
                                                              {/* <div className="mr-3">{index + 1}</div> */}
                                                              {quspart.english_question_answers
                                                                .filter(
                                                                  CorrAns =>
                                                                    parseInt(
                                                                      CorrAns.english_answer_is_correct
                                                                    ) === 1
                                                                )
                                                                .map(
                                                                  (
                                                                    qusAns,
                                                                    index1
                                                                  ) => (
                                                                    <div
                                                                      key={
                                                                        index1
                                                                      }
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          qusAns.english_answer_feedback
                                                                            ? qusAns.english_answer_feedback
                                                                            : "&nbsp;",
                                                                      }}
                                                                    ></div>
                                                                  )
                                                                )}
                                                            </div>
                                                          )
                                                        }
                                                      }
                                                    )}
                                                </div>
                                              </div>
                                            </>
                                          </li>
                                        </ul>

                                        <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            
                                            <div className={activeindex + 1 > 1 ? "" : "invisible"}>
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(activeindex)
                                                }}>
                                                Prev
                                                </Button>
                                            </div>

                                            {/* Middle Button (Replace) */}
                                            <div className="text-center">
                                                <Button
                                                className="btn btn-danger cs-btn-danger mt-1"
                                                disabled={!!summativeQuestionData?.questions.find(q => q.questionId === InnerActivityData?.english_question_id && q.assignedCount > 0)}
                                                onClick={() => {
                                                    handleAssignClick(InnerActivityData?.english_question_id)
                                                }}
                                                >
                                                Assign Actvity
                                                </Button>
                                            </div>

                                            {/* Right Button (Next) */}
                                            <div
                                                className={
                                                    activeindex + 1 <
                                                    ActivityData.LessonActivitiesQuestions.length
                                                    ? ""
                                                    : "invisible"
                                                }
                                            >
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(
                                                    activeindex + 1 + 1
                                                    )
                                                }}>
                                                Next
                                                </Button>
                                            </div>
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else {
                                  return (
                                    <p className="text-center">No question</p>
                                  )
                                }
                              }
                            }
                          )
                        } else if (
                          ActivityData1 &&
                          ActivityData1.fk_sub_id &&
                          parseInt(ActivityData1.fk_sub_id) === 2
                        ) {
                          return ActivityData1.question.map(
                            (InnerActivityData, index) => {
                              if (index === 0) {
                                if (
                                  InnerActivityData &&
                                  InnerActivityData.question_parts &&
                                  InnerActivityData.question_parts.length > 0
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div className="hw-list mt-4 pb-100">
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                                {InnerActivityData.question_new_topic &&
                                                InnerActivityData
                                                  .question_new_topic.level_name
                                                  ? InnerActivityData
                                                      .question_new_topic
                                                      .level_name + " /"
                                                  : null}

                                                {InnerActivityData.question_new_topic &&
                                                InnerActivityData
                                                  .question_new_topic.topic_name
                                                  ? InnerActivityData
                                                      .question_new_topic
                                                      .topic_name + " /"
                                                  : null}

                                                {InnerActivityData.question_new_topic &&
                                                InnerActivityData
                                                  .question_new_topic
                                                  .sub_topics_name
                                                  ? InnerActivityData
                                                      .question_new_topic
                                                      .sub_topics_name + " /"
                                                  : null}
                                              </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.question_id
                                                    ? InnerActivityData.question_id
                                                    : null}
                                                </p>
                                                <span>
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                                <span  className="p-1" id={`Popover_${activeindex + 1}`} type="button">
                                                  <i class="fa fa-info font-size-16"></i>
                                                </span>
                                                {/* Popover */}
                                                  <UncontrolledPopover
                                                    placement="bottom"
                                                    trigger="legacy"
                                                    target={`Popover_${activeindex + 1}`} // Matches button ID
                                                  >
                                                    <PopoverBody className="shadow rounded bg-white p-3" style={{ width: "600px" }}>
                                                      <h5 className="text-center"><strong>User Guide for Math Answers</strong></h5>

                                                      {/* Accordion */}
                                                        <Accordion open={openAccordion} toggle={toggleAccordion}>
                                                            <AccordionItem>
                                                              <AccordionHeader targetId="1"><strong>Numbers</strong></AccordionHeader>
                                                              <AccordionBody accordionId="1" className="p-0 answerQuide">
                                                                {/* Table inside Accordion */}
                                                                <Table bordered size="sm" className="mb-0 text-start">
                                                                  <thead>
                                                                    <tr  className="align-middle fw-bold">
                                                                      <th>Math Expression</th>
                                                                      <th>How to Type</th>
                                                                      <th>Not Accepted</th>
                                                                      <th>Similar Expressions</th>
                                                                      <th>Tips</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    <tr className="align-middle">
                                                                      <td>Whole number e.g. <span className="text-danger">15</span></td>
                                                                      <td><span className="text-danger">15</span></td>
                                                                      <td>
                                                                          • 1.5<br></br>
                                                                          • 1,5<br></br>
                                                                          • 1/5<br></br>
                                                                          • 1\5<br></br>
                                                                          • 015
                                                                      </td>
                                                                      <td>
                                                                          • 234<br></br>
                                                                          • 4078<br></br>
                                                                          • 37580<br></br>
                                                                          • 194026<br></br>
                                                                          • -763<br></br>
                                                                      </td>
                                                                      <td>
                                                                        Make sure to include a negative sign “-” for negative numbers. 
                                                                      </td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Decimal e.g. <span className="text-danger">0.67</span></td>
                                                                      <td><span className="text-danger">0.67</span></td>
                                                                      <td>
                                                                          • 067<br></br>
                                                                          • 0,67<br></br>
                                                                          • 0:67<br></br>
                                                                          • 0_67
                                                                      </td>
                                                                      <td>
                                                                          • 0.2<br></br>
                                                                          • 1.45<br></br>
                                                                          • 0.768<br></br>
                                                                          • 30.85<br></br>
                                                                          • -4.10<br></br>
                                                                      </td>
                                                                      <td>
                                                                          Make sure to include a dot “.” for decimals.
                                                                      </td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Multiple answers e.g. <span className="text-danger">1, 2, 4</span></td>
                                                                      <td><span className="text-danger">1, 2, 4</span></td>
                                                                      <td>
                                                                        • 124<br></br>
                                                                        • 1.2.4<br></br>
                                                                        • 1_2_4<br></br>
                                                                        • 1&2&4
                                                                      </td>
                                                                      <td>
                                                                        • 3, 6<br></br>
                                                                        • 5, 10, 15, 20<br></br>
                                                                        • -3, -2, -1
                                                                      </td>
                                                                      <td>Make sure to include a comma, followed by a space for each answer.</td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Ratio e.g. <span className="text-danger">2:3</span></td>
                                                                      <td><span className="text-danger">2:3</span></td>
                                                                      <td>
                                                                        • 23<br></br>
                                                                        • 2.3<br></br>
                                                                        • 2,3<br></br>
                                                                        • 2_3
                                                                      </td>
                                                                      <td>
                                                                        • 3:2<br></br>
                                                                        • 7:10<br></br>
                                                                        • 12:5<br></br>
                                                                        • 1:4:9<br></br>
                                                                        • 6:3:8
                                                                      </td>
                                                                      <td>Make sure to include a colon “:” for ratios.</td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Indices e.g. <span className="text-danger">2^3</span></td>
                                                                      <td><span className="text-danger">2^3</span></td>
                                                                      <td>
                                                                        • 23<br></br>
                                                                        • 2.3<br></br>
                                                                        • 2,3<br></br>
                                                                        • 2_3
                                                                      </td>
                                                                      <td>
                                                                        • 3^4<br></br>
                                                                        • 10^2<br></br>
                                                                        • -5^3<br></br>
                                                                        • 8^(-5)
                                                                      </td>
                                                                      <td>Make sure to include “^” for indices.</td>
                                                                    </tr>
                                                                  </tbody>
                                                                </Table>
                                                              </AccordionBody>
                                                            </AccordionItem>
                                                            <AccordionItem>
                                                              <AccordionHeader targetId="2"><strong>Fractions</strong></AccordionHeader>
                                                              <AccordionBody accordionId="2" className="p-0 answerQuide">
                                                                {/* Table inside Accordion */}
                                                                <Table bordered size="sm" className="mb-0 text-start">
                                                                  <thead>
                                                                    <tr  className="align-middle fw-bold">
                                                                      <th>Math Expression</th>
                                                                      <th>How to Type</th>
                                                                      <th>Not Accepted</th>
                                                                      <th>Similar Expressions</th>
                                                                      <th>Tips</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    <tr className="align-middle">
                                                                      <td>Proper fraction e.g. <span className="text-danger">3/5</span></td>
                                                                      <td><span className="text-danger">3/5</span></td>
                                                                      <td>
                                                                        • 35<br></br>
                                                                        • 3 5 (with a space)<br></br>
                                                                        • 3.5<br></br>
                                                                        • 3,5<br></br>
                                                                        • 3_5<br></br>
                                                                        • 3\5
                                                                      </td>
                                                                      <td>
                                                                        • 1/2<br></br>
                                                                        • 4/7<br></br>
                                                                        • -5/8<br></br>
                                                                        • 10/11<br></br>
                                                                        • -7/12
                                                                      </td>
                                                                      <td>Make sure to include a slash “/” for fractions.</td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Improper fraction e.g. <span className="text-danger">9/2</span></td>
                                                                      <td><span className="text-danger">9/2</span></td>
                                                                      <td>
                                                                        • 92<br></br>
                                                                        • 9 2 (with a space)<br></br>
                                                                        • 9.2<br></br>
                                                                        • 9,2<br></br>
                                                                        • 9_2<br></br>
                                                                        • 9\2
                                                                      </td>
                                                                      <td>
                                                                        • 7/3<br></br>
                                                                        • 8/5<br></br>
                                                                        • -13/3<br></br>
                                                                        • 14/11<br></br>
                                                                        • -23/10
                                                                      </td>
                                                                      <td>If the question does not specify the answer to be an improper fraction, its equivalent mixed number is accepted as well.</td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>Mixed number e.g. <span className="text-danger">2 3/5</span></td>
                                                                      <td><span className="text-danger">2 3/5</span></td>
                                                                      <td>
                                                                        • 23/5 (without a space)<br></br>
                                                                        • 2.3/5<br></br>
                                                                        • 2,3/5<br></br>
                                                                        • 2_3/5
                                                                      </td>
                                                                      <td>
                                                                        • 4 1/3<br></br>
                                                                        • 7 5/8<br></br>
                                                                        • 10 3/4<br></br>
                                                                        • -2 2/7<br></br>
                                                                        • -10 4/11
                                                                      </td>
                                                                      <td>Make sure to include a space between the whole number and the proper fraction.</td>
                                                                    </tr>
                                                                  </tbody>
                                                                </Table>
                                                              </AccordionBody>
                                                            </AccordionItem>
                                                            <AccordionItem>
                                                              <AccordionHeader targetId="3"><strong>Time</strong></AccordionHeader>
                                                              <AccordionBody accordionId="3" className="p-0 answerQuide">
                                                                {/* Table inside Accordion */}
                                                                <Table bordered size="sm" className="mb-0 text-start">
                                                                  <thead>
                                                                    <tr  className="align-middle fw-bold">
                                                                      <th>Math Expression</th>
                                                                      <th>How to Type</th>
                                                                      <th>Not Accepted</th>
                                                                      <th>Similar Expressions</th>
                                                                      <th>Tips</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    <tr className="align-middle">
                                                                      <td>12-hour clock e.g. <span className="text-danger">4:15</span></td>
                                                                      <td><span className="text-danger">4:15</span></td>
                                                                      <td>
                                                                          • 415<br></br>
                                                                          • 4 15 (with a space)<br></br>
                                                                          • 4.15<br></br>
                                                                          • 04:15<br></br>
                                                                          • 4,15
                                                                      </td>
                                                                      <td>
                                                                          • 2:30<br></br>
                                                                          • 5:45<br></br>
                                                                          • 8:05<br></br>
                                                                          • 10:22<br></br>
                                                                          • 12:03
                                                                      </td>
                                                                      <td>
                                                                          Make sure to include a colon “:” for times on the 12-hour clock.<br></br>
                                                                          “am” or “pm” may be in the question; do not include the unit in the answer.
                                                                      </td>
                                                                    </tr>
                                                                    <tr className="align-middle">
                                                                      <td>24-hour time e.g. <span className="text-danger">16 15</span></td>
                                                                      <td><span className="text-danger">16 15</span> (with a space)</td>
                                                                      <td>
                                                                          • 1615<br></br>
                                                                          • 16.15<br></br>
                                                                          • 16:15<br></br>
                                                                          • 16,15
                                                                      </td>
                                                                      <td>
                                                                          • 02 30<br></br>
                                                                          • 17 45<br></br>
                                                                          • 20 05<br></br>
                                                                          • 20 22<br></br>
                                                                          • 00 03
                                                                      </td>
                                                                      <td>
                                                                          Make sure to include a space between the hours and the minutes.
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </Table>
                                                              </AccordionBody>
                                                            </AccordionItem>
                                                            <AccordionItem>
                                                              <AccordionHeader targetId="4"><strong>Algebra</strong></AccordionHeader>
                                                              <AccordionBody accordionId="4" className="p-0 answerQuide">
                                                                {/* Table inside Accordion */}
                                                                <Table bordered size="sm" className="mb-0 text-start">
                                                                  <thead>
                                                                    <tr  className="align-middle fw-bold">
                                                                      <th>Math Expression</th>
                                                                      <th>How to Type</th>
                                                                      <th>Not Accepted</th>
                                                                      <th>Similar Expressions</th>
                                                                      <th>Tips</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                  <tr className="align-middle">
                                                                    <td>12-hour clock e.g. <span className="text-danger">4:15</span></td>
                                                                    <td><span className="text-danger">4:15</span></td>
                                                                    <td>
                                                                        • 415<br></br>
                                                                        • 4 15 (with a space)<br></br>
                                                                        • 4.15<br></br>
                                                                        • 04:15<br></br>
                                                                        • 4,15
                                                                    </td>
                                                                    <td>
                                                                        • 2:30<br></br>
                                                                        • 5:45<br></br>
                                                                        • 8:05<br></br>
                                                                        • 10:22<br></br>
                                                                        • 12:03
                                                                    </td>
                                                                    <td>
                                                                        Make sure to include a colon “:” for times on the 12-hour clock.<br></br>
                                                                        “am” or “pm” may be in the question; do not include the unit in the answer.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle">
                                                                    <td>24-hour time e.g. <span className="text-danger">16 15</span></td>
                                                                    <td><span className="text-danger">16 15</span> (with a space)</td>
                                                                    <td>
                                                                        • 1615<br></br>
                                                                        • 16.15<br></br>
                                                                        • 16:15<br></br>
                                                                        • 16,15
                                                                    </td>
                                                                    <td>
                                                                        • 02 30<br></br>
                                                                        • 17 45<br></br>
                                                                        • 20 05<br></br>
                                                                        • 20 22<br></br>
                                                                        • 00 03
                                                                    </td>
                                                                    <td>
                                                                        Make sure to include a space between the hours and the minutes.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle fw-bold">
                                                                    <td>Algebraic term e.g. <span className="text-danger">2x</span></td>
                                                                    <td><span className="text-danger">2x</span></td>
                                                                    <td>
                                                                        • 2<br></br>
                                                                        • 2 x (with a space)<br></br>
                                                                        • 2xx<br></br>
                                                                        • xx<br></br>
                                                                        • x2
                                                                    </td>
                                                                    <td>
                                                                        • y<br></br>
                                                                        • 5k<br></br>
                                                                        • 10b<br></br>
                                                                        • -3p<br></br>
                                                                        • -12m
                                                                    </td>
                                                                    <td>
                                                                        Write 1y as y.<br></br>
                                                                        Make sure to include the negative sign “-” for negative algebraic terms.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle">
                                                                    <td>Algebraic term e.g. <span className="text-danger">4pq</span></td>
                                                                    <td><span className="text-danger">4pq</span></td>
                                                                    <td>
                                                                        • 4qp<br></br>
                                                                        • pq4<br></br>
                                                                        • qp4<br></br>
                                                                        • p4q<br></br>
                                                                        • q4p
                                                                    </td>
                                                                    <td>
                                                                        • ab<br></br>
                                                                        • 3mn<br></br>
                                                                        • -cd<br></br>
                                                                        • -5yz
                                                                    </td>
                                                                    <td>
                                                                        Write 1ab as ab.<br></br>
                                                                        Make sure to include the negative sign “-” for negative algebraic terms.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle">
                                                                    <td>Algebraic term with power e.g. <span className="text-danger">3x²</span></td>
                                                                    <td><span className="text-danger">3x^2</span></td>
                                                                    <td>
                                                                        • 3x2<br></br>
                                                                        • 3xx<br></br>
                                                                        • 3x_2<br></br>
                                                                        • (3x)^2
                                                                    </td>
                                                                    <td>
                                                                        • y^2<br></br>
                                                                        • 5k^3<br></br>
                                                                        • 10b^2<br></br>
                                                                        • -3p^2<br></br>
                                                                        • -12m^3
                                                                    </td>
                                                                    <td>
                                                                        Make sure to include “^” for indices.<br></br>
                                                                        To type “^”, type “Shift”, followed by “6” on the keyboard.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle">
                                                                    <td>Linear expression (positive terms only) e.g. <span className="text-danger">4x + 5</span></td>
                                                                    <td><span className="text-danger">4x + 5</span></td>
                                                                    <td>
                                                                        • 5 + 4x (with a space before and after the +)<br></br>
                                                                        • x4 + 5<br></br>
                                                                        • 5 + x4<br></br>
                                                                        • xxxx + 5<br></br>
                                                                        • xxxx5<br></br>
                                                                        • 5xxxx
                                                                    </td>
                                                                    <td>
                                                                        • a + 1<br></br>
                                                                        • 2h + 3<br></br>
                                                                        • m + 3n + 4<br></br>
                                                                        • 4p + 5q + 6
                                                                    </td>
                                                                    <td>
                                                                        Make sure to include a space before and after the “+” sign, after the first term.<br></br>
                                                                        Flag (⚐) the question if an equivalent expression is not accepted.
                                                                    </td>
                                                                </tr>
                                                                <tr className="align-middle">
                                                                    <td>Linear expression (positive and negative terms) e.g. <span className="text-danger">4x - 5</span></td>
                                                                    <td><span className="text-danger">4x - 5</span></td>
                                                                    <td>
                                                                        • -5 + 4x (with a space before and after the -)<br></br>
                                                                        • x4 - 5<br></br>
                                                                        • -5 + x4<br></br>
                                                                        • xxxx - 5<br></br>
                                                                        • xxxx5<br></br>
                                                                        • 5xxxx
                                                                    </td>
                                                                    <td>
                                                                        • a - 1<br></br>
                                                                        • -1 + a<br></br>
                                                                        • 2h - 3<br></br>
                                                                        • -3 + 2h<br></br>
                                                                        • m - 3n + 4<br></br>
                                                                        • 4p - 5q - 6
                                                                    </td>
                                                                    <td>
                                                                        Make sure to include a space before and after the “+” or “-” sign, after the first term.<br></br>
                                                                        Flag (⚐) the question if an equivalent expression is not accepted.
                                                                    </td>
                                                                  </tr>
                                                                  <tr className="align-middle">
                                                                    <td>Linear expression (negative terms only) e.g. <span className="text-danger">-4x - 5</span></td>
                                                                    <td><span className="text-danger">-4x - 5</span></td>
                                                                    <td>
                                                                        • -5 - 4x<br></br>
                                                                        • -x4 - 5<br></br>
                                                                        • -5 - x4<br></br>
                                                                        • -xxxx - 5<br></br>
                                                                        • -xxxx5<br></br>
                                                                        • -5xxxx
                                                                    </td>
                                                                    <td>
                                                                        • -a - 1<br></br>
                                                                        • -1 - a<br></br>
                                                                        • -2h - 3<br></br>
                                                                        • -3 - 2h<br></br>
                                                                        • -m - 3n - 4<br></br>
                                                                        • -4p - 5q - 6
                                                                    </td>
                                                                    <td>
                                                                      Make sure to include a space before and after the “-” sign, after the first term.
                                                                    </td>
                                                                  </tr>
                                                                  <tr className="align-middle">
                                                                    <td>Algebraic fraction e.g. <span className="text-danger">(3y)/4</span></td>
                                                                    <td><span className="text-danger">(3y)/4</span></td>
                                                                    <td>
                                                                        • 3y/4<br></br>
                                                                        • 3/(4y)<br></br>
                                                                        • (3y/4)<br></br>
                                                                        • [3y]/4
                                                                    </td>
                                                                    <td>
                                                                        • a/4<br></br>
                                                                        • (2x)/3<br></br>
                                                                        • (2/3)x<br></br>
                                                                        • b^2/4<br></br>
                                                                        • (1/4)b^2<br></br>
                                                                        • (4x^2)/5<br></br>
                                                                        • (4/5)x^2<br></br>
                                                                        • (m + 3)/7<br></br>
                                                                        • (5n - 4)/6
                                                                    </td>
                                                                    <td>
                                                                      Note the placement of the round brackets.
                                                                    </td>
                                                                  </tr>
                                                                  <tr className="align-middle">
                                                                    <td>Algebraic fraction (with negative term) e.g. <span className="text-danger">-(3y)/4</span></td>
                                                                    <td><span className="text-danger">-(3y)/4</span></td>
                                                                    <td>
                                                                        • -3y/4<br></br>
                                                                        • -3/(4y)<br></br>
                                                                        • -(3y/4)<br></br>
                                                                        • (-3y/4)<br></br>
                                                                        • -[3y]/4
                                                                    </td>
                                                                    <td>
                                                                        • -a/4<br></br>
                                                                        • -(2x)/3<br></br>
                                                                        • (-2x)/3<br></br>
                                                                        • -(2/3)x<br></br>
                                                                        • -(m + 3)/7<br></br>
                                                                        • (-m - 3)/7<br></br>
                                                                        • -(5n - 4)/6<br></br>
                                                                        • (-5n + 4)/6
                                                                    </td>
                                                                    <td>
                                                                      Note the placement of the round brackets.
                                                                    </td>
                                                                  </tr>
                                                                  <tr className="align-middle">
                                                                    <td>Quadratic expression e.g. <span className="text-danger">5x^2 + 7</span></td>
                                                                    <td><span className="text-danger">5x^2 + 7</span></td>
                                                                    <td>
                                                                        • 5x2 + 7<br></br>
                                                                        • 7 + 5x2<br></br>
                                                                        • x^25 + 7<br></br>
                                                                        • 7 + x^25
                                                                    </td>
                                                                    <td>
                                                                        • y^2 + 4<br></br>
                                                                        • 4 + y^2<br></br>
                                                                        • k^2 - 5<br></br>
                                                                        • -5 + k^2<br></br>
                                                                        • 4m^2 - 3<br></br>
                                                                        • -3 + 4m^2<br></br>
                                                                        • x^2 + 3x - 1<br></br>
                                                                        • 2n^2 - 5n + 4
                                                                    </td>
                                                                    <td>
                                                                      Make sure to include “^” for the quadratic term.<br></br>
                                                                      Make sure to include a space before and after the “+” or “-” sign, after the first term.
                                                                    </td>
                                                                  </tr>
                                                                  </tbody>
                                                                </Table>
                                                              </AccordionBody>
                                                            </AccordionItem>
                                                        </Accordion>

                                                    </PopoverBody>
                                                  </UncontrolledPopover>
                                              </div>
                                            </div>

                                            <div
                                              className="mt-4"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.question_text
                                                    ? InnerActivityData.question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>

                                            {/* Past question */}
                                            {InnerActivityData.question_parts &&
                                              InnerActivityData.question_parts.map(
                                                (quspart, index) => {
                                                  const stuAnswersarray =
                                                    quspart.StudentAnsAttempts.map(
                                                      stuAns => {
                                                        try {
                                                          return JSON.parse(
                                                            stuAns.student_answer
                                                          )
                                                        } catch (error) {
                                                          console.error(
                                                            "Error parsing JSON:",
                                                            error
                                                          )
                                                          return null // or handle the error in an appropriate way
                                                        }
                                                      }
                                                    ) || [] // Extracting session keys

                                                  // Assuming stuAnswersarray is a nested array
                                                  const flattenedStuAnswers =
                                                    [].concat(
                                                      ...stuAnswersarray
                                                    )
                                                  let serialNumber = 0
                                                  return (
                                                    <div key={index}>
                                                      <div class="d-flex justify-content-between gap-3 mb-3">
                                                      <div className="d-flex gap-2 flex-row ">
                                                        <div className="mr-3">
                                                          {index + 1}
                                                          {")"}
                                                        </div>
                                                        <div
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              quspart.part_text
                                                                ? quspart.part_text
                                                                    .replace(
                                                                      /\[(\d+)Answer char=\d+\]/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /\[Answer char=\d+\]/g,
                                                                      ""
                                                                    )
                                                                : null,
                                                          }}
                                                        ></div>
                                                      </div>
                                                      {quspart.StudentAnsAttempts.length > 0 ? 
                                                        quspart.markedReport && quspart.markedReport > 0 ?
                                                          <div>
                                                            {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                            <span className="badge bg-warning font-size-12 mt-auto mb-2">Override</span>
                                                          </div>
                                                        :
                                                        null
                                                        : 
                                                        null
                                                      }
                                                    </div>
                                                      {/* Anse category statement Star */}
                                                      {quspart.part_answer_type ===
                                                      2 ? (
                                                        <ul className="dg-selector width-controll list-unstyled mb-0">
                                                          {quspart.question_answers &&
                                                            quspart.question_answers.map(
                                                              (
                                                                qusAns,
                                                                index1
                                                              ) => {
                                                                if (
                                                                  quspart
                                                                    .StudentAnsAttempts
                                                                    .length > 0
                                                                ) {
                                                                  return quspart.StudentAnsAttempts.map(
                                                                    (
                                                                      qusStuAns,
                                                                      stuAnsindex
                                                                    ) => {
                                                                      // Your logic for filtering student answers and determining status_color and border_color
                                                                      const stuAnswersarray =
                                                                        quspart.StudentAnsAttempts.filter(
                                                                          stuAns =>
                                                                            stuAns.atempt_count ===
                                                                            stuAnsindex +
                                                                              1
                                                                        ).map(
                                                                          stuAns => {
                                                                            try {
                                                                              return JSON.parse(
                                                                                stuAns.student_answer
                                                                              )
                                                                            } catch (error) {
                                                                              console.error(
                                                                                "Error parsing JSON:",
                                                                                error
                                                                              )
                                                                              return null // or handle the error in an appropriate way
                                                                            }
                                                                          }
                                                                        ) || []

                                                                      //console.log(stuAnswersarray);
                                                                      // Assuming stuAnswersarray is a nested array
                                                                      const flattenedStuAnswers =
                                                                        [].concat(
                                                                          ...stuAnswersarray
                                                                        )
                                                                      //  let cleanedText = qusAns.answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '') || '';
                                                                      //  let resultTest = cleanedText.toLowerCase().trim();
                                                                      //  let answers = resultTest.split('|') || [];
                                                                      //  let firstAnswer = answers[0] ? answers[0].trim() : "";
                                                                      //  let secondAnswer = answers[1] ? answers[1].trim() : "";

                                                                      if (
                                                                        qusAns.answer_is_correct ===
                                                                        1
                                                                      ) {
                                                                        let filteredStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_part_id
                                                                                ) &&
                                                                              parseInt(
                                                                                qusStuAns.attempt_status
                                                                              ) ===
                                                                                1 &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        let filteredAllStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_part_id
                                                                                ) &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        return (
                                                                          <li
                                                                            key={
                                                                              index1
                                                                            }
                                                                            className={
                                                                              filteredStuAns.length >
                                                                              0
                                                                                ? " input_box m_input_box"
                                                                                : "input_box m_input_box"
                                                                            }
                                                                          >
                                                                            <input
                                                                              id={
                                                                                index1 +
                                                                                Math.floor(
                                                                                  Math.random() *
                                                                                    5
                                                                                )
                                                                              }
                                                                              type="text"
                                                                              className={
                                                                                parseInt(
                                                                                  qusStuAns.attempt_status
                                                                                ) ===
                                                                                1
                                                                                  ? "answersuccess"
                                                                                  : "answererror"
                                                                              }
                                                                              value={
                                                                                filteredAllStuAns
                                                                                  .filter(
                                                                                    item =>
                                                                                      parseInt(
                                                                                        item.answer_id
                                                                                      ) ===
                                                                                      parseInt(
                                                                                        qusAns.answer_id
                                                                                      )
                                                                                  )
                                                                                  .map(
                                                                                    item =>
                                                                                      item.text
                                                                                  )
                                                                                  .find(
                                                                                    text =>
                                                                                      text !==
                                                                                      undefined
                                                                                  ) ||
                                                                                "" // Find the first non-undefined text value
                                                                              }
                                                                              disabled={
                                                                                true
                                                                              }
                                                                              //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                              onChange={e =>
                                                                                handletext(
                                                                                  e,
                                                                                  qusAns.answer_id,
                                                                                  qusAns.answer_part_id
                                                                                )
                                                                              }
                                                                              // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            />
                                                                          </li>
                                                                        )
                                                                      }
                                                                    }
                                                                  )
                                                                } else {
                                                                  return (
                                                                    <li
                                                                      key={
                                                                        index1
                                                                      }
                                                                      className={
                                                                        "input_box m_input_box"
                                                                      }
                                                                    >
                                                                      <input
                                                                        id={
                                                                          index1 +
                                                                          Math.floor(
                                                                            Math.random() *
                                                                              5
                                                                          )
                                                                        }
                                                                        type="text"
                                                                        className={
                                                                          "answereditor"
                                                                        }
                                                                        value={
                                                                          "" // Find the first non-undefined text value
                                                                        }
                                                                        disabled={
                                                                          true
                                                                        }
                                                                        //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                        //onChange={(e) => handletext(e, qusAns.answer_id, qusAns.answer_part_id)}
                                                                        // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                      />
                                                                    </li>
                                                                  )
                                                                }
                                                              }
                                                            )}
                                                        </ul>
                                                      ) : quspart.part_answer_type ===
                                                        4 ? (
                                                        //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                        <ul className="dg-selector width-controll list-unstyled mb-0">
                                                          {quspart.question_answers &&
                                                            rearrangeEvenOdd(
                                                              quspart.question_answers
                                                            ).map(
                                                              (
                                                                qusAns,
                                                                index1
                                                              ) => {
                                                                const cleanText =
                                                                  qusAns.answer_text
                                                                    .replace(
                                                                      /&nbsp;/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /`/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /<[^>]*>/g,
                                                                      ""
                                                                    )
                                                                    .trim()

                                                                const hasImage =
                                                                  /<img\s+[^>]*>/gi.test(
                                                                    qusAns.answer_text
                                                                  )

                                                                if (
                                                                  !cleanText &&
                                                                  !hasImage
                                                                ) {
                                                                  return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                }

                                                                serialNumber++
                                                                let filteredStuAns =
                                                                  flattenedStuAnswers.filter(
                                                                    stuAns =>
                                                                      parseInt(
                                                                        stuAns.part_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_part_id
                                                                        ) &&
                                                                      parseInt(
                                                                        stuAns.answer_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_id
                                                                        )
                                                                  ) || []

                                                                 //OverRide check status start
                                                                  let filteredStuAnsoverridedata = quspart.StudentAnsAttempts.filter(stuAns => ((parseInt(stuAns.attempt_status) ===1))
                                                                  ) || [];
                                                                  const stuAnswersoverridearray = filteredStuAnsoverridedata.map(stuAns => {
                                                                    try {
                                                                        return JSON.parse(stuAns.student_answer);
                                                                        } catch (error) {
                                                                            console.error('Error parsing JSON:', error);
                                                                            return null; // or handle the error in an appropriate way
                                                                        }
                                                                    }) || [];
                                                                  const flattenedoverrideStuAnswers = [].concat(...stuAnswersoverridearray);

                                                                  let filteredStuAnsoverride = flattenedoverrideStuAnswers.filter(stuAns => ((parseInt(stuAns.part_id) === parseInt(qusAns.answer_part_id)) 
                                                                  && (parseInt(stuAns.answer_id) === parseInt(qusAns.answer_id)))
                                                                  ) || [];
                                                                  
                                                                  //OverRide check status end

                                                                var status_color =
                                                                  "selector-general cursor-pointer"
                                                                var border_color =
                                                                  "border-start-secondary"
                                                                if (
                                                                  filteredStuAns.length >
                                                                  0
                                                                ) {
                                                                  if(parseInt(qusAns.answer_is_correct) === 1 && !quspart?.markedReport > 0){
                                                                    status_color = 'selector-success';
                                                                    border_color = 'border-start-success';
                                                                  }else if(filteredStuAnsoverride.length > 0 && quspart.markedReport > 0) {
                                                                    status_color = 'selector-success';
                                                                    border_color = 'border-start-success';
                                                                  } else {
                                                                    status_color = "selector-wrong ";
                                                                    border_color = "border-start-danger";
                                                                  }
                                                                }
                                                                //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                return (
                                                                  <li
                                                                    className={
                                                                      status_color +
                                                                      " choose m_choose"
                                                                    }
                                                                    key={index1}
                                                                  >
                                                                    <div className="p-2 px-3 font-size-18">
                                                                      {
                                                                        serialNumber
                                                                      }
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        "p-2 dg-media " +
                                                                        {
                                                                          border_color,
                                                                        }
                                                                      }
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          qusAns.answer_text
                                                                            ? qusAns.answer_text
                                                                            : null,
                                                                      }}
                                                                    ></div>
                                                                  </li>
                                                                )
                                                              }
                                                            )}
                                                        </ul>
                                                      ) : (
                                                        <p className="text-center">
                                                          No option
                                                        </p>
                                                      )}
                                                      {/* Anse category statement end */}
                                                    </div>
                                                  )
                                                }
                                              )}

                                            <>
                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                Feedback
                                              </h4>

                                              {InnerActivityData.question_parts &&
                                                InnerActivityData.question_parts.map(
                                                  (quspart, index) => {
                                                    let filteredAns =
                                                      quspart.question_answers.filter(
                                                        CorrAns =>
                                                          parseInt(
                                                            CorrAns.answer_is_correct
                                                          ) === 1
                                                      )
                                                    return filteredAns.map(
                                                      (qusAns, feedindex1) => {
                                                        return (
                                                          <div
                                                            className="m_feedBack"
                                                            style={{
                                                              border:
                                                                "1px solid #1a1a1a",
                                                              borderRadius:
                                                                "4px",
                                                              fontSize: "16px",
                                                            }}
                                                          >
                                                            {/* <div className="p-2 px-3 font-size-18">{feedindex1 + 1}</div> */}
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  qusAns.answer_text
                                                                    ? qusAns.answer_text
                                                                    : null,
                                                              }}
                                                            ></div>
                                                          </div>
                                                        )
                                                      }
                                                    )
                                                  }
                                                )}
                                            </>
                                          </li>
                                        </ul>
                                        <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            
                                            <div className={activeindex + 1 > 1 ? "" : "invisible"}>
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(activeindex)
                                                }}>
                                                Prev
                                                </Button>
                                            </div>

                                            {/* Middle Button (Replace) */}
                                            <div className="text-center">
                                                <Button
                                                className="btn btn-danger cs-btn-danger mt-1"
                                                disabled={!!summativeQuestionData?.questions.find(q => q.questionId === InnerActivityData?.question_id && q.assignedCount > 0)}
                                                onClick={() => {
                                                    handleAssignClick(InnerActivityData?.question_id)
                                                }}
                                                >
                                                Assign Actvity
                                                </Button>
                                            </div>

                                            {/* Right Button (Next) */}
                                            <div
                                                className={
                                                    activeindex + 1 <
                                                    ActivityData.LessonActivitiesQuestions.length
                                                    ? ""
                                                    : "invisible"
                                                }
                                            >
                                                <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={() => {
                                                    toggleCustom(
                                                    activeindex + 1 + 1
                                                    )
                                                }}>
                                                Next
                                                </Button>
                                            </div>
                                        </div>
                                        
                                      </div>
                                    </TabPane>
                                  )
                                } else {
                                  return (
                                    <p className="text-center">No question</p>
                                  )
                                }
                              }
                            }
                          )
                        }
                      }
                    )
                  : null}
              </TabContent>

              {/* <Comprehension triggerFunction={handleFunctionTrigger} triggerSubmitFunction={handleSubmitFunction} data={ActiviteQAData} part={ActivityPart} responceData={submitOtherData} key={activityKey}/> */}
            </div>
          </Container>
        </div>
      </MathJax>
    </React.Fragment>
  )
})

export default PreviewSummativeDetails
